{
  "about.blocks": "Modererede servere",
  "about.contact": "Kontakt:",
  "about.default_locale": "Standard",
  "about.disclaimer": "Mastodon er gratis, open-source software og et varemærke tilhørende Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Begrundelse ikke tilgængelig",
  "about.domain_blocks.preamble": "Mastodon tillader generelt, at du ser indhold og interagere med brugere fra enhver anden server i fediverset. Disse er undtagelserne, som er implementeret på netop denne server.",
  "about.domain_blocks.silenced.explanation": "Du vil generelt ikke se profiler og indhold fra denne server, medmindre du udtrykkeligt slår den op eller vælger den ved at følge.",
  "about.domain_blocks.silenced.title": "Begrænset",
  "about.domain_blocks.suspended.explanation": "Data fra denne server hverken behandles, gemmes eller udveksles, hvilket umuliggør interaktion eller kommunikation med brugere fra denne server.",
  "about.domain_blocks.suspended.title": "Suspenderet",
  "about.language_label": "Sprog",
  "about.not_available": "Denne information er ikke blevet gjort tilgængelig på denne server.",
  "about.powered_by": "Decentraliserede sociale medier drevet af {mastodon}",
  "about.rules": "Serverregler",
  "account.account_note_header": "Personligt notat",
  "account.activity": "Aktivitet",
  "account.add_note": "Tilføj en personlig note",
  "account.add_or_remove_from_list": "Tilføj eller fjern fra lister",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Blokeret",
  "account.badges.bot": "Automatiseret",
  "account.badges.domain_blocked": "Blokeret domæne",
  "account.badges.group": "Gruppe",
  "account.badges.muted": "Skjult",
  "account.badges.muted_until": "Skjult indtil {until}",
  "account.block": "Blokér @{name}",
  "account.block_domain": "Blokér domænet {domain}",
  "account.block_short": "Bloker",
  "account.blocked": "Blokeret",
  "account.cancel_follow_request": "Annullér anmodning om at følge",
  "account.copy": "Kopiér link til profil",
  "account.direct": "Nævn @{name} privat",
  "account.disable_notifications": "Giv mig ikke længere en notifikation, når @{name} laver indlæg",
  "account.edit_note": "Rediger personlig note",
  "account.edit_profile": "Redigér profil",
  "account.edit_profile_short": "Rediger",
  "account.enable_notifications": "Giv mig besked, når @{name} laver indlæg",
  "account.endorse": "Fremhæv på profil",
  "account.familiar_followers_many": "Følges af {name1}, {name2} og {othersCount, plural, one {# mere, man kender} other {# mere, du kender}}",
  "account.familiar_followers_one": "Følges af {name1}",
  "account.familiar_followers_two": "Følges af {name1} og {name2}",
  "account.featured": "Fremhævet",
  "account.featured.accounts": "Profiler",
  "account.featured.collections": "Samlinger",
  "account.featured.new_collection": "Ny samling",
  "account.field_overflow": "Vis fuldt indhold",
  "account.filters.all": "Al aktivitet",
  "account.filters.boosts_toggle": "Vis fremhævelser",
  "account.filters.posts_boosts": "Indlæg og fremhævelser",
  "account.filters.posts_only": "Indlæg",
  "account.filters.posts_replies": "Indlæg og svar",
  "account.filters.replies_toggle": "Vis svar",
  "account.follow": "Følg",
  "account.follow_back": "Følg tilbage",
  "account.follow_back_short": "Følg tilbage",
  "account.follow_request": "Anmod om at følge",
  "account.follow_request_cancel": "Annuller anmodning",
  "account.follow_request_cancel_short": "Annullér",
  "account.follow_request_short": "Anmod",
  "account.followers": "Følgere",
  "account.followers.empty": "Ingen følger denne bruger endnu.",
  "account.followers_counter": "{count, plural, one {{counter} følger} other {{counter} følgere}}",
  "account.followers_you_know_counter": "{counter} du kender",
  "account.following": "Følger",
  "account.following_counter": "{count, plural, one {{counter} fulgt} other {{counter} fulgte}}",
  "account.follows.empty": "Denne bruger følger ikke nogen endnu.",
  "account.follows_you": "Følger dig",
  "account.go_to_profile": "Gå til profil",
  "account.hame.invalid_handle": "Handle utilgængeligt",
  "account.hide_reblogs": "Skjul fremhævelser fra @{name}",
  "account.in_memoriam": "Til minde om.",
  "account.join_modal.day": "Dag",
  "account.join_modal.me": "Du tilmeldte dig {server}",
  "account.join_modal.me_anniversary": "Tillykke med dit fedivers-jubilæum! Du tilmeldte dig {server}",
  "account.join_modal.me_today": "Det er din første dag på {server}!",
  "account.join_modal.other": "{name} tilmeldte sig {server}",
  "account.join_modal.other_today": "Det er {name}’s første dag på {server}!",
  "account.join_modal.share.celebrate": "Del et indlæg for at fejre begivenheden",
  "account.join_modal.share.intro": "Del et introindlæg",
  "account.join_modal.share.welcome": "Del et velkomstindlæg",
  "account.join_modal.years": "{number, plural, one {år} other {år}}",
  "account.joined_short": "Oprettet",
  "account.languages": "Skift abonnementssprog",
  "account.last_active": "Senest aktiv",
  "account.link_verified_on": "Ejerskab af dette link blev tjekket {date}",
  "account.locked_info": "Denne kontos fortrolighedsstatus er sat til låst. Ejeren bedømmer manuelt, hvem der kan følge vedkommende.",
  "account.media": "Medier",
  "account.mention": "Nævn @{name}",
  "account.menu.add_to_collection": "Føj til samling…",
  "account.menu.add_to_list": "Føj til liste…",
  "account.menu.block": "Blokér konto",
  "account.menu.block_domain": "Blokér {domain}",
  "account.menu.copied": "Kontolink kopieret til udklipsholderen",
  "account.menu.copy": "Kopiér link",
  "account.menu.direct": "Omtal privat",
  "account.menu.hide_reblogs": "Skjul fremhævelser på tidslinje",
  "account.menu.mention": "Omtal",
  "account.menu.mute": "Skjul konto",
  "account.menu.note.description": "Kun synlig for dig",
  "account.menu.open_original_page": "Vis på {domain}",
  "account.menu.open_original_page_no_domain": "Se på original server",
  "account.menu.remove_follower": "Fjern følger",
  "account.menu.report": "Anmeld konto",
  "account.menu.share": "Del…",
  "account.menu.show_reblogs": "Vis fremhævelser på tidslinje",
  "account.menu.unblock": "Fjern blokering af konto",
  "account.menu.unblock_domain": "Fjern blokering af {domain}",
  "account.menu.unmute": "Vis konto igen",
  "account.moved_to": "{name} har angivet, at vedkommendes nye konto nu er:",
  "account.mute": "Skjul @{name}",
  "account.mute_notifications_short": "Sluk for notifikationer",
  "account.mute_short": "Skjul",
  "account.muted": "Skjult",
  "account.mutual": "I følger hinanden",
  "account.name.copy": "Kopiér handle",
  "account.name.help.domain": "{domain} er den server, der er vært for brugerens profil og indlæg.",
  "account.name.help.domain_self": "{domain} er din server, der er vært for din profil og indlæg.",
  "account.name.help.footer": "Ligesom du kan sende e-mails til folk, der bruger forskellige e-mailudbydere, kan du interagere med folk på andre Mastodon-servere og med alle, der bruger andre Fediverse-apps.",
  "account.name.help.header": "Et handle svarer til en e-mailadresse",
  "account.name.help.invalid_explanation": "Dette kan ske, når en bruger ændrer sit brugernavn, og er som regel kun midlertidigt. Hvis problemet fortsætter, kan det skyldes, at serveren er utilgængelig, eller en fejlkonfiguration hos dem.",
  "account.name.help.invalid_header": "Denne brugers handle opdateres",
  "account.name.help.username": "{username} er denne kontos brugernavn på deres server. En konto på en anden server kan have det samme brugernavn.",
  "account.name.help.username_self": "{username} er dit brugernavn på denne server. En konto på en anden server kan have det samme brugernavn.",
  "account.name_info": "Hvad betyder dette?",
  "account.no_bio": "Ingen beskrivelse til rådighed.",
  "account.node_modal.callout": "Personlige noter er kun synlige for dig.",
  "account.node_modal.edit_title": "Rediger personlig note",
  "account.node_modal.error_unknown": "Kunne ikke gemme noten",
  "account.node_modal.field_label": "Personlig note",
  "account.node_modal.save": "Gem",
  "account.node_modal.title": "Tilføj en personlig note",
  "account.note.edit_button": "Rediger",
  "account.note.title": "Personlig note (kun synlige for dig)",
  "account.open_original_page": "Åbn oprindelig side",
  "account.pending": "Afventer",
  "account.posts": "Indlæg",
  "account.remove_from_followers": "Fjern {name} fra følgere",
  "account.report": "Anmeld @{name}",
  "account.requested_follow": "{name} har anmodet om at følge dig",
  "account.share": "Del @{name}s profil",
  "account.show_reblogs": "Vis fremhævelser fra @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} indlæg} other {{counter} indlæg}}",
  "account.timeline.pinned": "Fastgjort",
  "account.timeline.pinned.view_all": "Se alle fastgjorte indlæg",
  "account.unblock": "Fjern blokering af @{name}",
  "account.unblock_domain": "Fjern blokering af domænet {domain}",
  "account.unblock_domain_short": "Afblokér",
  "account.unblock_short": "Fjern blokering",
  "account.unendorse": "Vis ikke på profil",
  "account.unfollow": "Følg ikke længere",
  "account.unmute": "Vis @{name} igen",
  "account.unmute_notifications_short": "Vis notifikationer igen",
  "account.unmute_short": "Vis igen",
  "account_edit.advanced_settings.bot_hint": "Signalér til andre, at kontoen hovedsageligt udfører automatiserede handlinger og muligvis ikke monitoreres",
  "account_edit.advanced_settings.bot_label": "Automatiseret konto",
  "account_edit.advanced_settings.title": "Avancerede indstillinger",
  "account_edit.bio.add_label": "Tilføj bio",
  "account_edit.bio.edit_label": "Rediger bio",
  "account_edit.bio.placeholder": "Tilføj en kort introduktion, så andre kan få et indtryk af, hvem du er.",
  "account_edit.bio.title": "Bio",
  "account_edit.bio_modal.add_title": "Tilføj bio",
  "account_edit.bio_modal.edit_title": "Rediger bio",
  "account_edit.column_button": "Færdig",
  "account_edit.column_title": "Rediger profil",
  "account_edit.custom_fields.add_label": "Tilføj felt",
  "account_edit.custom_fields.edit_label": "Rediger felt",
  "account_edit.custom_fields.placeholder": "Tilføj dine pronominer, eksterne links eller andet, du gerne vil dele.",
  "account_edit.custom_fields.reorder_button": "Omsorter felter",
  "account_edit.custom_fields.tip_content": "Du kan nemt øge troværdigheden af din Mastodon-konto ved at verificere links til alle websteder, du ejer.",
  "account_edit.custom_fields.tip_title": "Tip: Tilføjelse af bekræftede links",
  "account_edit.custom_fields.title": "Brugerdefinerede felter",
  "account_edit.custom_fields.verified_hint": "Hvordan tilføjer jeg et bekræftet link?",
  "account_edit.display_name.add_label": "Tilføj visningsnavn",
  "account_edit.display_name.edit_label": "Rediger visningsnavn",
  "account_edit.display_name.placeholder": "Dit visningsnavn er det navn, der vises på din profil og i tidslinjer.",
  "account_edit.display_name.title": "Visningsnavn",
  "account_edit.featured_hashtags.edit_label": "Tilføj hashtags",
  "account_edit.featured_hashtags.placeholder": "Hjælp andre med at identificere og få hurtig adgang til dine yndlingsemner.",
  "account_edit.featured_hashtags.title": "Fremhævede hashtags",
  "account_edit.field_actions.delete": "Slet felt",
  "account_edit.field_actions.edit": "Rediger felt",
  "account_edit.field_delete_modal.confirm": "Er du sikker på, at du vil slette dette brugerdefinerede felt? Denne handling kan ikke fortrydes.",
  "account_edit.field_delete_modal.delete_button": "Slet",
  "account_edit.field_delete_modal.title": "Slet brugerdefineret felt?",
  "account_edit.field_edit_modal.add_title": "Tilføj brugerdefineret felt",
  "account_edit.field_edit_modal.discard_confirm": "Kassér",
  "account_edit.field_edit_modal.discard_message": "Du har ændringer, der ikke er gemt. Er du sikker på, at du vil kassere dem?",
  "account_edit.field_edit_modal.edit_title": "Rediger brugerdefineret felt",
  "account_edit.field_edit_modal.length_warning": "Anbefalet tegngrænse overskredet. Mobilbrugere kan muligvis ikke se hele dit felt.",
  "account_edit.field_edit_modal.link_emoji_warning": "Vi fraråder brug af brugerdefinerede emoji i kombination med url'er. Brugerdefinerede felter, der indeholder begge dele, vises kun som tekst i stedet for som et link for at undgå forvirring hos brugerne.",
  "account_edit.field_edit_modal.name_hint": "F.eks. “Personligt websted”",
  "account_edit.field_edit_modal.name_label": "Etiket",
  "account_edit.field_edit_modal.url_warning": "For at tilføje et link, skal du inkludere {protocol} i begyndelsen.",
  "account_edit.field_edit_modal.value_hint": "F.eks. “https://example.me”",
  "account_edit.field_edit_modal.value_label": "Værdi",
  "account_edit.field_reorder_modal.drag_cancel": "Trækningen blev annulleret. Feltet \"{item}\" blev sluppet.",
  "account_edit.field_reorder_modal.drag_end": "Feltet \"{item}\" blev sluppet.",
  "account_edit.field_reorder_modal.drag_instructions": "For at omarrangere brugerdefinerede felter skal du trykke på mellemrumstasten eller Enter. Mens du trækker, kan du bruge piletasterne til at flytte feltet op eller ned. Tryk på mellemrumstasten eller Enter igen for at placere feltet i sin nye position, eller tryk på Escape for at annullere.",
  "account_edit.field_reorder_modal.drag_move": "Feltet \"{item}\" blev flyttet.",
  "account_edit.field_reorder_modal.drag_over": "Feltet \"{item}\" blev flyttet over \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Samlede feltet \"{item}\" op.",
  "account_edit.field_reorder_modal.handle_label": "Træk feltet \"{item}\"",
  "account_edit.field_reorder_modal.title": "Omarrangér felter",
  "account_edit.image_alt_modal.add_title": "Tilføj alt-tekst",
  "account_edit.image_alt_modal.details_content": "GØR GERNE: <ul> <li>Beskriv dig selv som vist på billedet</li> <li>Brug tredje person (f.eks. “Alex“ i stedet for “mig“)</li> <li>Vær kortfattet – et par ord er ofte nok</li> </ul> GØR IKKE: <ul> <li>Start ikke med “Foto af“ – det er overflødigt for skærmlæsere</li> </ul> EKSEMPEL: <ul> <li>“Alex iført en grøn skjorte og briller”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Tips: Alt-tekst til profilfotos",
  "account_edit.image_alt_modal.edit_title": "Rediger alt-tekst",
  "account_edit.image_alt_modal.text_hint": "Alt-tekst hjælper brugere af skærmlæsere med at forstå dit indhold.",
  "account_edit.image_alt_modal.text_label": "Alt-tekst",
  "account_edit.image_delete_modal.confirm": "Er du sikker på, at du vil slette dette billede? Denne handling kan ikke fortrydes.",
  "account_edit.image_delete_modal.delete_button": "Slet",
  "account_edit.image_delete_modal.title": "Slet billede?",
  "account_edit.image_edit.add_button": "Tilføj billede",
  "account_edit.image_edit.alt_add_button": "Tilføj alt-tekst",
  "account_edit.image_edit.alt_edit_button": "Rediger alt-tekst",
  "account_edit.image_edit.remove_button": "Fjern billede",
  "account_edit.image_edit.replace_button": "Erstat billede",
  "account_edit.item_list.delete": "Slet {name}",
  "account_edit.item_list.edit": "Rediger {name}",
  "account_edit.name_modal.add_title": "Tilføj visningsnavn",
  "account_edit.name_modal.edit_title": "Rediger visningsnavn",
  "account_edit.profile_tab.button_label": "Tilpas",
  "account_edit.profile_tab.hint.description": "Disse indstillinger tilpasser hvad brugere ser på {server} i de officielle apps, men de gælder muligvis ikke for brugere på andre servere og tredjeparts apps.",
  "account_edit.profile_tab.hint.title": "Visninger vil stadig variere",
  "account_edit.profile_tab.show_featured.description": "‘Fremhævet‘ er en valgfri fane, hvor du kan fremvise andre konti.",
  "account_edit.profile_tab.show_featured.title": "Vis fanebladet ‘Fremhævet‘",
  "account_edit.profile_tab.show_media.description": "‘Medier’ er en valgfri fane, der viser dine indlæg, der indeholder billeder eller videoer.",
  "account_edit.profile_tab.show_media.title": "Vis fanebladet ‘Medier‘",
  "account_edit.profile_tab.show_media_replies.description": "Når aktiveret, viser fanen Medier både dine indlæg og svar på andres indlæg.",
  "account_edit.profile_tab.show_media_replies.title": "Inkludér svar på fanen 'Medier'",
  "account_edit.profile_tab.show_relations.description": "Viser de konti, du følger, samt dine følgere for andre brugere på din profil. Andre kan stadig se, om du følger dem.",
  "account_edit.profile_tab.show_relations.title": "Vis ‘Følgere‘ og ‘Fulgte’",
  "account_edit.profile_tab.subtitle": "Tilpas, hvordan din profil vises.",
  "account_edit.profile_tab.title": "Indstillinger for profilvisning",
  "account_edit.save": "Gem",
  "account_edit.upload_modal.back": "Tilbage",
  "account_edit.upload_modal.done": "Færdig",
  "account_edit.upload_modal.next": "Næste",
  "account_edit.upload_modal.step_crop.zoom": "Zoom",
  "account_edit.upload_modal.step_upload.button": "Gennemse filer",
  "account_edit.upload_modal.step_upload.dragging": "Slip for at uploade",
  "account_edit.upload_modal.step_upload.header": "Vælg et billede",
  "account_edit.upload_modal.step_upload.hint": "WEBP, PNG, GIF eller JPG-format, op til {limit} MB.{br}Billede vil blive skaleret til {width}x{height} px.",
  "account_edit.upload_modal.title_add.avatar": "Tilføj profilfoto",
  "account_edit.upload_modal.title_add.header": "Tilføj coverfoto",
  "account_edit.upload_modal.title_replace.avatar": "Erstat profilfoto",
  "account_edit.upload_modal.title_replace.header": "Erstat coverfoto",
  "account_edit.verified_modal.details": "Øg troværdigheden af din Mastodon-profil ved at verificere links til personlige websteder. Sådan fungerer det:",
  "account_edit.verified_modal.invisible_link.details": "Føj linket til din header. Det vigtige er rel=\"me\", som forhindrer imitatorer på websteder med brugergenereret indhold. Du kan endda bruge et link-tag i sidens header i stedet for {tag}, men HTML-koden skal være tilgængelig uden at afvikle JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Hvordan gør jeg linket usynligt?",
  "account_edit.verified_modal.step1.header": "Kopiér HTML-koden nedenfor og indsæt i headeren på dit websted",
  "account_edit.verified_modal.step2.details": "Hvis du allerede har tilføjet dit websted som et brugerdefineret felt, skal du slette og tilføje det igen for at udløse bekræftelse.",
  "account_edit.verified_modal.step2.header": "Tilføj dit websted som et brugerdefineret felt",
  "account_edit.verified_modal.title": "Sådan tilføjes et bekræftet link",
  "account_edit_tags.add_tag": "Tilføj #{tagName}",
  "account_edit_tags.column_title": "Rediger etiket",
  "account_edit_tags.help_text": "Fremhævede hashtags hjælper brugere med at finde og interagere med din profil. De vises som filtre i aktivitetsvisningen på din profilside.",
  "account_edit_tags.max_tags_reached": "Du har nået det maksimale antal fremhævede hashtags.",
  "account_edit_tags.search_placeholder": "Angiv et hashtag…",
  "account_edit_tags.suggestions": "Forslag:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# indlæg} other {# indlæg}}",
  "account_list.hidden_notice": "Dette kan kun ses af dig. Hvis du vil vise denne liste for andre, skal du gå til <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# konto} other {# konti}}",
  "admin.dashboard.daily_retention": "Brugerfastholdelsesrate pr. dag efter tilmelding",
  "admin.dashboard.monthly_retention": "Brugerfastholdelsesrate pr. måned efter tilmelding",
  "admin.dashboard.retention.average": "Gennemsnit",
  "admin.dashboard.retention.cohort": "Tilmeldingsmåned",
  "admin.dashboard.retention.cohort_size": "Nye brugere",
  "admin.impact_report.instance_accounts": "Konti profiler, som dette ville slette",
  "admin.impact_report.instance_followers": "Følgere, vores brugere ville miste",
  "admin.impact_report.instance_follows": "Følgere, deres brugere ville miste",
  "admin.impact_report.title": "Resumé af effekt",
  "alert.need_reload.message": "Mastodon er blevet opdateret. Nogle ting fungerer muligvis ikke korrekt, før du genindlæser siden.",
  "alert.rate_limited.message": "Forsøg igen efter {retry_time, time, medium}.",
  "alert.rate_limited.title": "Hastighedsbegrænset",
  "alert.unexpected.message": "En uventet fejl opstod.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Alt-text",
  "alt_text_modal.add_alt_text": "Tilføj alternativ tekst",
  "alt_text_modal.add_text_from_image": "Tilføj tekst fra billede",
  "alt_text_modal.cancel": "Annullér",
  "alt_text_modal.change_thumbnail": "Skift miniature",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Beskriv dette for personer med nedsat hørelse…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Beskriv dette for personer med nedsat syn…",
  "alt_text_modal.done": "Færdig",
  "announcement.announcement": "Bekendtgørelse",
  "annual_report.announcement.action_build": "Byg min Wrapstodon",
  "annual_report.announcement.action_dismiss": "Nej tak",
  "annual_report.announcement.action_view": "Vis min Wrapstodon",
  "annual_report.announcement.description": "Få mere at vide om dit engagement på Mastodon i det forgangne år.",
  "annual_report.announcement.title": "Wrapstodon {year} er her",
  "annual_report.nav_item.badge": "Ny",
  "annual_report.shared_page.donate": "Donér",
  "annual_report.shared_page.footer": "Genereret med {heart} af Mastodon-teamet",
  "annual_report.shared_page.footer_server_info": "{username} bruger {domain}, et af mange fællesskaber drevet af Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} fortsatte med at jagte indlæg, der kunne fremhæves, og styrkede andre skabere med perfekt sigte.",
  "annual_report.summary.archetype.booster.desc_self": "Du fortsatte med at jagte indlæg, der kunne fremhæves, og styrkede andre skabere med perfekt sigte.",
  "annual_report.summary.archetype.booster.name": "Bueskytten",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Vi ved, at {name} var derude et eller andet sted og nød Mastodon på sin egen stille måde.",
  "annual_report.summary.archetype.lurker.desc_self": "Vi ved, at du var derude et eller andet sted og nød Mastodon på din egen stille måde.",
  "annual_report.summary.archetype.lurker.name": "Den stoiske",
  "annual_report.summary.archetype.oracle.desc_public": "{name} oprettede flere nye indlæg end svar og holdt dermed Mastodon frisk og fremtidsorienteret.",
  "annual_report.summary.archetype.oracle.desc_self": "Du oprettede flere nye indlæg end svar og holdt dermed Mastodon frisk og fremtidsorienteret.",
  "annual_report.summary.archetype.oracle.name": "Oraklet",
  "annual_report.summary.archetype.pollster.desc_public": "{name} oprettede flere afstemninger end andre indlægstyper og opdyrkede nysgerrighed på Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Du oprettede flere afstemninger end andre indlægstyper og opdyrkede nysgerrighed på Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Den undrende",
  "annual_report.summary.archetype.replier.desc_public": "{name} svarede ofte på andres indlæg og berigede Mastodon med nye diskussioner.",
  "annual_report.summary.archetype.replier.desc_self": "Du svarede ofte på andres indlæg og berigede Mastodon med nye diskussioner.",
  "annual_report.summary.archetype.replier.name": "Sommerfuglen",
  "annual_report.summary.archetype.reveal": "Afslør min arketype",
  "annual_report.summary.archetype.reveal_description": "Tak fordi du er en del af Mastodon! Nu er det tid til at finde ud af, hvilken arketype du var i {year}.",
  "annual_report.summary.archetype.title_public": "{name}'s arketype",
  "annual_report.summary.archetype.title_self": "Din arketype",
  "annual_report.summary.close": "Luk",
  "annual_report.summary.copy_link": "Kopiér link",
  "annual_report.summary.followers.new_followers": "{count, plural, one {ny følger} other {nye følgere}}",
  "annual_report.summary.highlighted_post.boost_count": "Dette indlæg blev fremhævet {count, plural, one {én gang} other {# gange}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Dette indlæg blev favoritmarkeret {count, plural, one {én gang} other {# gange}}.",
  "annual_report.summary.highlighted_post.reply_count": "Dette indlæg fik {count, plural, one {ét svar} other {# svar}}.",
  "annual_report.summary.highlighted_post.title": "Mest populært indlæg",
  "annual_report.summary.most_used_app.most_used_app": "mest benyttede app",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "mest benyttede hashtag",
  "annual_report.summary.most_used_hashtag.used_count": "Du har inkluderet dette hashtag i {count, plural, one {ét indlæg} other {# indlæg}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} inkluderede dette hashtag i {count, plural, one {ét indlæg} other {# indlæg}}.",
  "annual_report.summary.new_posts.new_posts": "nye indlæg",
  "annual_report.summary.percentile.text": "<topLabel>Dermed er du i top</topLabel><percentage></percentage><bottomLabel>af {domain}-brugere.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Vi fortæller det ikke til nogen.",
  "annual_report.summary.share_elsewhere": "Del andetsteds",
  "annual_report.summary.share_message": "Min arketype er {archetype}!",
  "annual_report.summary.share_on_mastodon": "Del på Mastodon",
  "attachments_list.unprocessed": "(ubehandlet)",
  "audio.hide": "Skjul lyd",
  "block_modal.no_collections": "I kan ikke tilføje hinanden til samlinger. I bliver automatisk fjernet fra hinandens eksisterende samlinger, hvis det er relevant.",
  "block_modal.remote_users_caveat": "Serveren {domain} vil blive bedt om at respektere din beslutning. Overholdelse er dog ikke garanteret, da nogle servere kan håndtere blokke forskelligt. Offentlige indlæg kan stadig være synlige for ikke-indloggede brugere.",
  "block_modal.show_less": "Vis mindre",
  "block_modal.show_more": "Vis flere",
  "block_modal.they_cant_mention": "I kan ikke omtale, følge eller citere hinanden.",
  "block_modal.they_cant_see_posts": "De kan ikke se dit indhold, og du kan ikke se deres.",
  "block_modal.they_will_know": "Vedkommende kan se den aktive blokering.",
  "block_modal.title": "Blokér bruger?",
  "block_modal.you_wont_see_mentions": "Du vil ikke se indlæg fra andre, hvor de omtales.",
  "boost_modal.combo": "Du kan trykke {combo} for at springe dette over næste gang",
  "boost_modal.reblog": "Fremhæv indlæg?",
  "boost_modal.undo_reblog": "Fjern fremhævelse af indlæg?",
  "bundle_column_error.copy_stacktrace": "Kopiér fejlrapport",
  "bundle_column_error.error.body": "Den anmodede side kunne ikke gengives. Dette kan skyldes flere typer fejl.",
  "bundle_column_error.error.title": "Åh nej!",
  "bundle_column_error.network.body": "Der opstod en fejl under indlæsning af denne side. Dette kan skyldes et midlertidigt problem med din internetforbindelse eller denne server.",
  "bundle_column_error.network.title": "Netværksfejl",
  "bundle_column_error.retry": "Forsøg igen",
  "bundle_column_error.return": "Tilbage til hjem",
  "bundle_column_error.routing.body": "Den ønskede side kunne ikke findes. Er du sikker på, at URL'en i adresselinjen er korrekt?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Luk",
  "bundle_modal_error.message": "Noget gik galt under indlæsningen af denne skærm.",
  "bundle_modal_error.retry": "Forsøg igen",
  "callout.dismiss": "Afvis",
  "carousel.current": "<sr>Dias</sr> {current, number} / {max, number}",
  "carousel.slide": "Dias {current, number} af {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} anbefalede tegn",
  "character_counter.required": "{currentLength}/{maxLength} tegn",
  "closed_registrations.other_server_instructions": "Eftersom Mastodon er decentraliseret, kan du oprette en konto på en anden server og stadig interagere med denne.",
  "closed_registrations_modal.description": "Oprettelse af en konto på {domain} er i øjeblikket ikke muligt, men husk på, at du ikke behøver en konto specifikt på {domain} for at bruge Mastodon.",
  "closed_registrations_modal.find_another_server": "Find en anden server",
  "closed_registrations_modal.preamble": "Mastodon er decentraliseret, så uanset hvor du opretter din konto, vil du være i stand til at følge og interagere med hvem som helst på denne server. Du kan endda selv være vært for den!",
  "closed_registrations_modal.title": "Oprettelse på Mastodon",
  "collection.share_modal.share_link_label": "Del link",
  "collection.share_modal.share_via_post": "Del på Mastodon",
  "collection.share_modal.share_via_system": "Del med…",
  "collection.share_modal.title": "Del samling",
  "collection.share_modal.title_new": "Del din nye samling!",
  "collection.share_template_other": "Tjek denne seje samling:",
  "collection.share_template_own": "Tjek min nye samling:",
  "collections.account_count": "{count, plural, one {# konto} other {# konti}}",
  "collections.accounts.empty_description": "Tilføj op til {count} konti",
  "collections.accounts.empty_editor_title": "Ingen er i denne samling endnu",
  "collections.accounts.empty_title": "Denne samling er tom",
  "collections.add_to_collection": "Tilføj {name} til samlinger",
  "collections.block_collection_owner": "Blokér konto",
  "collections.by_account": "af {account_handle}",
  "collections.collection_description": "Beskrivelse",
  "collections.collection_language": "Sprog",
  "collections.collection_language_none": "Intet",
  "collections.collection_name": "Navn",
  "collections.collection_topic": "Emne",
  "collections.confirm_account_removal": "Er du sikker på, at du vil fjerne denne konto fra denne samling?",
  "collections.content_warning": "Indholdsadvarsel",
  "collections.continue": "Fortsæt",
  "collections.copy_link": "Kopiér link",
  "collections.copy_link_confirmation": "Link til samling kopieret til udklipsholderen",
  "collections.create.accounts_title": "Hvem vil du fremhæve i denne samling?",
  "collections.create.basic_details_title": "Grundlæggende oplysninger",
  "collections.create.steps": "Trin {step}/{total}",
  "collections.create_collection": "Opret samling",
  "collections.create_new_collection": "Opret ny samling",
  "collections.delete_collection": "Slet samling",
  "collections.description_length_hint": "Begrænset til 100 tegn",
  "collections.detail.author_added_you_on_date": "{author} tilføjede dig {date}",
  "collections.detail.loading": "Indlæser samling…",
  "collections.detail.revoke_inclusion": "Fjern mig",
  "collections.detail.sensitive_content": "Følsomt indhold",
  "collections.detail.sensitive_note": "Beskrivelsen og kontiene er muligvis ikke egnet for alle.",
  "collections.detail.share": "Del denne samling",
  "collections.detail.you_are_in_this_collection": "Du er med i denne samling",
  "collections.edit_details": "Rediger detaljer",
  "collections.error_loading_collections": "Der opstod en fejl under indlæsning af disse samlinger.",
  "collections.hidden_accounts_description": "Du har blokeret eller skjult {count, plural, one {denne bruger} other {disse brugere}}",
  "collections.hidden_accounts_link": "{count, plural, one {# skjult konto} other {# skjulte konti}}",
  "collections.hints.accounts_counter": "{count}/{max} konti",
  "collections.last_updated_at": "Senest opdateret: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# samling} other {# samlinger}}",
  "collections.list.created_by_author": "Oprettet af {name}",
  "collections.list.created_by_you": "Oprettet af dig",
  "collections.list.featuring_you": "Med dig",
  "collections.manage_accounts": "Administrer konti",
  "collections.mark_as_sensitive": "Markér som sensitiv",
  "collections.mark_as_sensitive_hint": "Skjuler samlingens beskrivelse og konti bag en indholdsadvarsel. Samlingens navn vil stadig være synligt.",
  "collections.maximum_collection_count_description": "Din server tillader oprettelse af op til {count} samlinger.",
  "collections.maximum_collection_count_reached": "Du har oprettet det maksimale antal samlinger",
  "collections.name_length_hint": "Begrænset til 40 tegn",
  "collections.new_collection": "Ny samling",
  "collections.pending_accounts.message": "Konti kan vises som afventende, når vi venter på et svar fra brugeren eller dennes server. Det er kun dig, der kan se de afventende konti.",
  "collections.pending_accounts.title": "Hvorfor ser jeg afventende konti?",
  "collections.remove_account": "Fjern",
  "collections.report_collection": "Anmeld denne samling",
  "collections.revoke_collection_inclusion": "Fjern mig selv fra denne samling",
  "collections.revoke_inclusion.confirmation": "Du er blevet fjernet fra \"{collection}\"",
  "collections.revoke_inclusion.error": "Der opstod en fejl, prøv igen senere.",
  "collections.search_accounts_label": "Søg efter en konto at tilføje",
  "collections.search_accounts_max_reached": "Du har tilføjet det maksimale antal konti",
  "collections.sensitive": "Sensitivt",
  "collections.share_short": "Del",
  "collections.sort_alphabetical": "Alfabetisk",
  "collections.sort_by": "Sortér efter:",
  "collections.sort_date_added": "Dato tilføjet",
  "collections.sort_last_active": "Senest aktiv",
  "collections.sort_most_followers": "Flest følgere",
  "collections.suggestions.can_not_add": "Kan ikke tilføjes",
  "collections.suggestions.can_not_add_desc": "Disse konti kan have fravalgt opdagelse, eller de kan være på en server, der ikke understøtter samlinger.",
  "collections.suggestions.must_follow": "Skal følge først",
  "collections.suggestions.must_follow_desc": "Disse konti gennemgår alle følge-anmodninger. Følgere kan tilføje dem til samlinger.",
  "collections.topic_hint": "Tilføj et hashtag, der hjælper andre med at forstå det overordnede emne for denne samling.",
  "collections.topic_special_chars_hint": "Specialtegn fjernes, når der gemmes",
  "collections.unlisted_collections_description": "Disse vises ikke på din profil for andre. Alle, der har linket, kan finde dem.",
  "collections.unlisted_collections_with_count": "Ikke-listede samlinger ({count})",
  "collections.view_collection": "Vis samling",
  "collections.visibility_public": "Offentlig",
  "collections.visibility_public_hint": "Kan opdages i søgeresultater og andre områder, hvor anbefalinger vises.",
  "collections.visibility_title": "Synlighed",
  "collections.visibility_unlisted": "Skjul offentligt",
  "collections.visibility_unlisted_hint": "Synlig for alle, der har et link. Skjult i søgeresultater og anbefalinger.",
  "column.about": "Om",
  "column.blocks": "Blokerede brugere",
  "column.bookmarks": "Bogmærker",
  "column.community": "Lokal tidslinje",
  "column.create_list": "Opret liste",
  "column.direct": "Private omtaler",
  "column.directory": "Gennemse profiler",
  "column.domain_blocks": "Blokerede domæner",
  "column.edit_list": "Redigér liste",
  "column.favourites": "Favoritter",
  "column.firehose": "Live feeds",
  "column.firehose_local": "Live feed for denne server",
  "column.firehose_singular": "Live feed",
  "column.follow_requests": "Følgeanmodninger",
  "column.home": "Hjem",
  "column.list_members": "Håndtér listemedlemmer",
  "column.lists": "Lister",
  "column.mutes": "Skjulte brugere",
  "column.notifications": "Notifikationer",
  "column.other_collections": "Samlinger af {name}",
  "column.pins": "Fastgjorte indlæg",
  "column.public": "Fælles tidslinje",
  "column.your_collections": "Dine samlinger",
  "column_back_button.label": "Tilbage",
  "column_header.hide_settings": "Skjul indstillinger",
  "column_header.moveLeft_settings": "Flyt kolonne til venstre",
  "column_header.moveRight_settings": "Flyt kolonne til højre",
  "column_header.pin": "Fastgør",
  "column_header.show_settings": "Vis indstillinger",
  "column_header.unpin": "Frigør",
  "column_search.cancel": "Annullér",
  "combobox.close_results": "Luk resultater",
  "combobox.loading": "Indlæser",
  "combobox.no_results_found": "Ingen resultater for denne søgning",
  "combobox.open_results": "Åbn resultater",
  "combobox.results_available": "{count, plural, one {# forslag} other {# forslag}} tilgængelig. Brug piletasterne op og ned til at navigere. Tryk på Enter-tasten for at vælge.",
  "community.column_settings.local_only": "Kun lokalt",
  "community.column_settings.media_only": "Kun medier",
  "community.column_settings.remote_only": "Kun udefra",
  "compose.error.blank_post": "Indlæg kan ikke være tomt.",
  "compose.language.change": "Skift sprog",
  "compose.language.search": "Søg efter sprog...",
  "compose.published.body": "Indlæg udgivet.",
  "compose.published.open": "Åbn",
  "compose.saved.body": "Indlæg gemt.",
  "compose_form.direct_message_warning_learn_more": "Få mere at vide",
  "compose_form.encryption_warning": "Indlæg på Mastodon er ikke ende-til-ende-krypteret. Del derfor ikke sensitiv information via Mastodon.",
  "compose_form.hashtag_warning": "Da indlægget ikke er offentligt, vises det ikke under noget hashtag, da kun offentlige indlæg er søgbare via hashtags.",
  "compose_form.lock_disclaimer": "Din konto er ikke {locked}. Enhver kan følge dig og se indlæg kun beregnet for følgere.",
  "compose_form.lock_disclaimer.lock": "låst",
  "compose_form.placeholder": "Hvad har du på hjerte?",
  "compose_form.poll.duration": "Afstemningens varighed",
  "compose_form.poll.multiple": "Multivalg",
  "compose_form.poll.option_placeholder": "Valgmulighed {number}",
  "compose_form.poll.single": "Enkeltvalg",
  "compose_form.poll.switch_to_multiple": "Ændr afstemning til flervalgstype",
  "compose_form.poll.switch_to_single": "Ændr afstemning til enkeltvalgstype",
  "compose_form.poll.type": "Stil",
  "compose_form.publish": "Publicér",
  "compose_form.reply": "Svar",
  "compose_form.save_changes": "Opdatér",
  "compose_form.spoiler.marked": "Fjern indholdsadvarsel",
  "compose_form.spoiler.unmarked": "Tilføj indholdsadvarsel",
  "compose_form.spoiler_placeholder": "Indholdsadvarsel (valgfri)",
  "confirmation_modal.cancel": "Afbryd",
  "confirmations.block.confirm": "Blokér",
  "confirmations.delete.confirm": "Slet",
  "confirmations.delete.message": "Er du sikker på, at du vil slette dette indlæg?",
  "confirmations.delete.title": "Slet indlæg?",
  "confirmations.delete_collection.confirm": "Slet",
  "confirmations.delete_collection.message": "Denne handling kan ikke fortrydes.",
  "confirmations.delete_collection.title": "Slet \"{name}\"?",
  "confirmations.delete_list.confirm": "Slet",
  "confirmations.delete_list.message": "Er du sikker på, at du vil slette denne liste permanent?",
  "confirmations.delete_list.title": "Slet liste?",
  "confirmations.discard_draft.confirm": "Kassér og fortsæt",
  "confirmations.discard_draft.edit.cancel": "Fortsæt redigering",
  "confirmations.discard_draft.edit.message": "Hvis du fortsætter, vil alle ændringer, du har foretaget i det indlæg, du er er ved at redigere, blive slettet.",
  "confirmations.discard_draft.edit.title": "Kassér ændringer til dit indlæg?",
  "confirmations.discard_draft.post.cancel": "Genoptag udkast",
  "confirmations.discard_draft.post.message": "Hvis du fortsætter, kasseres det indlæg, du er i gang med at udforme.",
  "confirmations.discard_draft.post.title": "Kassér dit indlægsudkast?",
  "confirmations.discard_edit_media.confirm": "Kassér",
  "confirmations.discard_edit_media.message": "Der er ugemte ændringer i mediebeskrivelsen eller forhåndsvisningen, kassér dem alligevel?",
  "confirmations.follow_to_list.confirm": "Følg og føj til liste",
  "confirmations.follow_to_list.message": "Du skal følge {name} for at føje vedkommende til en liste.",
  "confirmations.follow_to_list.title": "Følg bruger?",
  "confirmations.hide_featured_tab.confirm": "Skjul fane",
  "confirmations.hide_featured_tab.intro": "Du kan til enhver tid ændre dette under <i>Rediger profil > Indstillinger for profil-fane</i>.",
  "confirmations.hide_featured_tab.message": "Dette vil skjule fanen for brugere på {serverName} og andre servere, der kører den nyeste version af Mastodon. Andre visninger kan variere.",
  "confirmations.hide_featured_tab.title": "Skjul fanen \"Fremhævet\"?",
  "confirmations.logout.confirm": "Log ud",
  "confirmations.logout.message": "Er du sikker på, at du vil logge ud?",
  "confirmations.logout.title": "Log ud?",
  "confirmations.missing_alt_text.confirm": "Tilføj alt-tekst",
  "confirmations.missing_alt_text.message": "Dit indlæg indeholder medier uden alt-tekst. Ved at tilføje beskrivelser gør du dit indhold tilgængeligt for flere brugere.",
  "confirmations.missing_alt_text.secondary": "Læg op alligevel",
  "confirmations.missing_alt_text.title": "Tilføj alt-tekst?",
  "confirmations.mute.confirm": "Skjul",
  "confirmations.private_quote_notify.cancel": "Tilbage til redigering",
  "confirmations.private_quote_notify.confirm": "Offentliggør indlæg",
  "confirmations.private_quote_notify.do_not_show_again": "Vis ikke denne besked igen",
  "confirmations.private_quote_notify.message": "Den person, du citerer og andre omtalte vil blive underrettet, og vil være i stand til at se dit indlæg, selv om de ikke følger dig.",
  "confirmations.private_quote_notify.title": "Del med følgere og omtalte brugere?",
  "confirmations.quiet_post_quote_info.dismiss": "Påmind mig ikke igen",
  "confirmations.quiet_post_quote_info.got_it": "Forstået",
  "confirmations.quiet_post_quote_info.message": "Når du citerer et stille offentligt indlæg, vil dit indlæg blive skjult fra trendtidslinjer.",
  "confirmations.quiet_post_quote_info.title": "Citering af stille offentlige indlæg",
  "confirmations.redraft.confirm": "Slet og omskriv",
  "confirmations.redraft.message": "Sikker på, at dette indlæg skal slettes og omskrives? Favoritter og fremhævelser går tabt, og svar til det oprindelige indlæg mister tilknytningen.",
  "confirmations.redraft.title": "Slet og omskriv indlæg?",
  "confirmations.remove_from_followers.confirm": "Fjern følger",
  "confirmations.remove_from_followers.message": "{name} vil ikke længere følge dig. Er du sikker på, at du vil fortsætte?",
  "confirmations.remove_from_followers.title": "Fjern følger?",
  "confirmations.revoke_collection_inclusion.confirm": "Fjern mig",
  "confirmations.revoke_collection_inclusion.message": "Kuratoren kan ikke tilføje dig til denne samling igen før om 24 timer. For permanent at forhindre, at vedkommende tilføjer dig til samlinger, kan du blokere vedkommende.",
  "confirmations.revoke_collection_inclusion.title": "Fjern dig selv fra denne samling?",
  "confirmations.revoke_quote.confirm": "Fjern indlæg",
  "confirmations.revoke_quote.message": "Denne handling kan ikke fortrydes.",
  "confirmations.revoke_quote.title": "Fjern indlæg?",
  "confirmations.unblock.confirm": "Fjern blokering",
  "confirmations.unblock.title": "Fjern blokering af {name}?",
  "confirmations.unfollow.confirm": "Følg ikke længere",
  "confirmations.unfollow.title": "Følg ikke længere {name}?",
  "confirmations.withdraw_request.confirm": "Annullér anmodning",
  "confirmations.withdraw_request.title": "Annullér anmodning om at følge {name}?",
  "content_warning.hide": "Skjul indlæg",
  "content_warning.show": "Vis alligevel",
  "content_warning.show_more": "Vis mere",
  "content_warning.show_short": "Vis",
  "conversation.delete": "Slet samtale",
  "conversation.mark_as_read": "Markér som læst",
  "conversation.open": "Vis samtale",
  "conversation.with": "Med {names}",
  "copy_icon_button.copied": "Kopieret til udklipsholderen",
  "copy_icon_button.copy_this_text": "Kopiér link til udklipsholderen",
  "copypaste.copied": "Kopieret",
  "copypaste.copy_to_clipboard": "Kopiér til udklipsholder",
  "custom_homepage.about": "Om",
  "custom_homepage.about_this_server": "Om denne server",
  "custom_homepage.administered_by": "Administreret af",
  "custom_homepage.contact": "Kontakt:",
  "custom_homepage.latest_activity": "Seneste aktivitet",
  "custom_homepage.these_are_the_latest_posts": "Disse er de seneste 40 indlæg fra konti på denne server.",
  "directory.federated": "Fra kendt fediverse",
  "directory.local": "Kun fra {domain}",
  "directory.new_arrivals": "Nyankomne",
  "directory.recently_active": "Aktive for nyligt",
  "disabled_account_banner.account_settings": "Kontoindstillinger",
  "disabled_account_banner.text": "Din konto {disabledAccount} er pt. deaktiveret.",
  "dismissable_banner.community_timeline": "Dette er de seneste offentlige indlæg fra personer med konti hostet af {domain}.",
  "dismissable_banner.dismiss": "Afvis",
  "dismissable_banner.public_timeline": "Dette er de seneste offentlige indlæg fra personer på fediverset, som folk på {domain} følger.",
  "domain_block_modal.block": "Blokér server",
  "domain_block_modal.block_account_instead": "Blokér i stedet @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Folk fra denne server kan interagere med dine gamle indlæg.",
  "domain_block_modal.they_cant_follow": "Ingen fra denne server kan følge dig.",
  "domain_block_modal.they_wont_know": "De ser ikke den aktive blokering.",
  "domain_block_modal.title": "Blokér domæne?",
  "domain_block_modal.you_will_lose_num_followers": "Du vil miste {followersCount, plural, one {{followersCountDisplay} følger} other {{followersCountDisplay} følgere}} og {followingCount, plural, one {{followingCountDisplay} person, du følger} other {{followingCountDisplay} personer, du følger}}.",
  "domain_block_modal.you_will_lose_relationships": "Du vil miste alle følgere og personer, du følger, fra denne server.",
  "domain_block_modal.you_wont_see_posts": "Du vil ikke se indlæg eller notifikationer fra brugere på denne server.",
  "dropdown.empty": "Vælg en indstilling",
  "email_subscriptions.email": "E-mail",
  "email_subscriptions.form.action": "Abonnér",
  "email_subscriptions.form.bottom": "Få indlæg sendt direkte til din indbakke uden at oprette en Mastodon-konto. Du kan til enhver tid afmelde dig. For mere information henvises til <a>privatlivspolitikken</a>.",
  "email_subscriptions.form.title": "Tilmeld dig e-mailopdateringer fra {name}",
  "email_subscriptions.submitted.lead": "Kig i din indbakke efter en e-mail, hvor du kan afslutte tilmeldingen til e-mailopdateringer.",
  "email_subscriptions.submitted.title": "Et trin mere",
  "email_subscriptions.validation.email.blocked": "Blokeret e-mail-udbyder",
  "email_subscriptions.validation.email.invalid": "Ugyldig e-mailadresse",
  "embed.instructions": "Indlejr dette indlæg på din hjemmeside ved at kopiere nedenstående kode.",
  "embed.preview": "Sådan kommer det til at se ud:",
  "emoji_button.activity": "Aktivitet",
  "emoji_button.clear": "Ryd",
  "emoji_button.custom": "Tilpasset",
  "emoji_button.flags": "Flag",
  "emoji_button.food": "Mad og drikke",
  "emoji_button.label": "Indsæt emoji",
  "emoji_button.nature": "Natur",
  "emoji_button.not_found": "Ingen matchende emojis fundet",
  "emoji_button.objects": "Objekter",
  "emoji_button.people": "Personer",
  "emoji_button.recent": "Ofte brugt",
  "emoji_button.search": "Søg...",
  "emoji_button.search_results": "Søgeresultater",
  "emoji_button.symbols": "Symboler",
  "emoji_button.travel": "Rejser og steder",
  "empty_column.account_featured.other": "{acct} har ikke fremhævet noget endnu.",
  "empty_column.account_featured_self.no_collections_button": "Opret en samling",
  "empty_column.account_featured_self.no_collections_hide_tab": "Skjul denne fane i stedet",
  "empty_column.account_featured_self.showcase_accounts": "Vis dine favoritkonti",
  "empty_column.account_featured_self.showcase_accounts_desc": "Samlinger er kuraterede lister over konti, der skal hjælpe andre med at opdage mere af Fediverset.",
  "empty_column.account_featured_unknown.other": "Denne konto har ikke fremhævet noget endnu.",
  "empty_column.account_hides_collections": "Brugeren har valgt ikke at gøre denne information tilgængelig",
  "empty_column.account_suspended": "Konto suspenderet",
  "empty_column.account_timeline": "Ingen indlæg her!",
  "empty_column.account_unavailable": "Profil utilgængelig",
  "empty_column.blocks": "Du har ikke blokeret nogle brugere endnu.",
  "empty_column.bookmarked_statuses": "Du har ingen bogmærkede indlæg endnu. Når du bogmærker ét, vil det dukke op hér.",
  "empty_column.collections": "{acct} har endnu ikke oprettet nogen samlinger.",
  "empty_column.collections.featured_in": "Du er ikke blevet tilføjet til nogen samlinger endnu.",
  "empty_column.collections.featured_in_undiscoverable": "For at andre kan føje dig til samlinger, skal du give tilladelse til at blive vist i opdagelsesfunktioner under <link>Præferencer > Fortrolighed og rækkevidde</link>",
  "empty_column.collections_self": "Du har endnu ikke oprettet nogen samlinger.",
  "empty_column.community": "Den lokale tidslinje er tom. Skriv noget offentligt for at sætte tingene i gang!",
  "empty_column.direct": "Du har ikke nogen private omtaler endnu. Når du sender eller modtager en, vil den blive vist her.",
  "empty_column.disabled_feed": "Dette feed er blevet deaktiveret af dine serveradministratorer.",
  "empty_column.domain_blocks": "Ingen blokerede domæner endnu.",
  "empty_column.explore_statuses": "Ingen nye trends lige nu. Tjek igen senere!",
  "empty_column.favourited_statuses": "Du har endnu ingen favoritindlæg. Når du føjer et opslag til favoritter, vil det dukke op her.",
  "empty_column.favourites": "Ingen har endnu føjet dette indlæg til favoritter. Når nogen gør det, vil det dukke op her.",
  "empty_column.follow_requests": "Du har endnu ingen følgeanmodninger. Når du modtager én, vil den dukke op her.",
  "empty_column.followed_tags": "Ingen hashtags følges endnu. Når det sker, vil de fremgå her.",
  "empty_column.hashtag": "Der er intet med dette hashtag endnu.",
  "empty_column.home": "Din hjem-tidslinje er tom! Følg flere personer, for at fylde den op.",
  "empty_column.list": "Der er ikke noget på denne liste endnu. Når medlemmer af denne liste udgiver nye indlæg, vil de blive vist her.",
  "empty_column.mutes": "Du har endnu ikke skjult nogle brugere.",
  "empty_column.notification_requests": "Alt er klar! Der er intet her. Når der modtages nye notifikationer, fremgår de her jævnfør dine indstillinger.",
  "empty_column.notifications": "Du har endnu ingen notifikationer. Når andre interagerer med dig, vil det fremgå her.",
  "empty_column.public": "Der er ikke noget her! Skriv noget offentligt, eller følg manuelt brugere fra andre servere for at se indhold",
  "empty_state.no_results": "Ingen resultater",
  "error.no_hashtag_feed_access": "Tilmeld dig eller log ind for at se og følge dette hashtag.",
  "error.unexpected_crash.explanation": "Grundet en fejl i vores kode, eller en netlæser-kompatibilitetsfejl, kunne siden ikke vises korrekt.",
  "error.unexpected_crash.explanation_addons": "Denne side kunne ikke vises korrekt. Fejlen skyldes sandsynligvis en browsertilføjelse eller automatiske oversættelsesværktøjer.",
  "error.unexpected_crash.next_steps": "Prøv at opfriske siden. Hjælper dette ikke, kan Mastodon muligvis stadig bruges via en anden netlæser eller app.",
  "error.unexpected_crash.next_steps_addons": "Prøv at deaktivere dem og genindlæse siden. Hvis det ikke hjælper, kan Mastodon muligvis stadig bruges via en anden netlæser eller app.",
  "errors.unexpected_crash.copy_stacktrace": "Kopiér stacktrace til udklipsholderen",
  "errors.unexpected_crash.report_issue": "Anmeld problem",
  "explore.suggested_follows": "Personer",
  "explore.title": "Trender",
  "explore.trending_links": "Nyheder",
  "explore.trending_statuses": "Indlæg",
  "explore.trending_tags": "Hashtags",
  "featured_carousel.current": "<sr>Indlæg</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {fastgjort indlæg} other {fastgjorte indlæg}}",
  "featured_carousel.slide": "Indlæg {current, number} af {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Du har for nylig lagt indlæg op om {items}. Skal disse tilføjes som fremhævede hashtags?",
  "featured_tags.suggestions.add": "Tilføj",
  "featured_tags.suggestions.added": "Du kan til enhver tid administrere dine fremhævede hashtags under <link>Rediger profil > Fremhævede hashtags</link>.",
  "featured_tags.suggestions.dismiss": "Nej tak",
  "filter_modal.added.context_mismatch_explanation": "Denne filterkategori omfatter ikke konteksten, hvorunder dette indlæg er tilgået. Redigér filteret, hvis indlægget også ønskes filtreret i denne kontekst.",
  "filter_modal.added.context_mismatch_title": "Kontekstmisforhold!",
  "filter_modal.added.expired_explanation": "Denne filterkategori er udløbet. Ændr dens udløbsdato, for at anvende den.",
  "filter_modal.added.expired_title": "Udløbet filter!",
  "filter_modal.added.review_and_configure": "Gå til {settings_link} for at gennemgå og konfigurere denne filterkategori yderligere.",
  "filter_modal.added.review_and_configure_title": "Filterindstillinger",
  "filter_modal.added.settings_link": "indstillingsside",
  "filter_modal.added.short_explanation": "Dette indlæg er nu føjet til følgende filterkategori: {title}.",
  "filter_modal.added.title": "Filter tilføjet!",
  "filter_modal.select_filter.context_mismatch": "gælder ikke for denne kontekst",
  "filter_modal.select_filter.expired": "udløbet",
  "filter_modal.select_filter.prompt_new": "Ny kategori: {name}",
  "filter_modal.select_filter.search": "Søg eller opret",
  "filter_modal.select_filter.subtitle": "Vælg en eksisterende kategori eller opret en ny",
  "filter_modal.select_filter.title": "Filtrér dette indlæg",
  "filter_modal.title.status": "Filtrér et indlæg",
  "filter_warning.matches_filter": "Matcher filteret “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "Fra {count, plural, =0 {ingen} one {én person} other {# personer}}, du måske kender",
  "filtered_notifications_banner.title": "Filtrerede notifikationer",
  "firehose.all": "Alle",
  "firehose.local": "Denne server",
  "firehose.remote": "Andre servere",
  "follow_request.authorize": "Godkend",
  "follow_request.reject": "Afvis",
  "follow_requests.unlocked_explanation": "Selvom din konto ikke er låst, mente {domain}-personalet, at du måske ville gennemgå følgeanmodninger fra disse konti manuelt.",
  "follow_suggestions.curated_suggestion": "Personaleudvalgt",
  "follow_suggestions.dismiss": "Vis ikke igen",
  "follow_suggestions.featured_longer": "Håndplukket af {domain}-teamet",
  "follow_suggestions.friends_of_friends_longer": "Populær blandt personer, du følger",
  "follow_suggestions.hints.featured": "Denne profil er håndplukket af {domain}-teamet.",
  "follow_suggestions.hints.friends_of_friends": "Denne profil er populær blandt de personer, du følger.",
  "follow_suggestions.hints.most_followed": "Denne profil er en af de mest fulgte på {domain}.",
  "follow_suggestions.hints.most_interactions": "Denne profil har for nylig fået stor opmærksomhed på {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Denne profil minder om de profiler, du senest har fulgt.",
  "follow_suggestions.personalized_suggestion": "Personligt forslag",
  "follow_suggestions.popular_suggestion": "Populært forslag",
  "follow_suggestions.popular_suggestion_longer": "Populær på {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Minder om profiler, du har fulgt for nylig",
  "follow_suggestions.view_all": "Vis alle",
  "follow_suggestions.who_to_follow": "Profiler, du kan følge",
  "followed_tags": "Hashtags, som følges",
  "followers.hide_other_followers": "Denne bruger har valgt ikke at gøre sine øvrige følgere synlige",
  "followers.title": "Følger {name}",
  "following.hide_other_following": "Denne bruger har valgt at skjule resten af sine fulgte konti",
  "following.title": "Følges af {name}",
  "footer.about": "Om",
  "footer.about_mastodon": "Om Mastodon",
  "footer.about_server": "Om {domain}",
  "footer.about_this_server": "Om",
  "footer.directory": "Profiloversigt",
  "footer.get_app": "Hent appen",
  "footer.keyboard_shortcuts": "Tastaturgenveje",
  "footer.privacy_policy": "Privatlivspolitik",
  "footer.source_code": "Vis kildekode",
  "footer.status": "Status",
  "footer.terms_of_service": "Tjenestevilkår",
  "form_error.blank": "Feltet må ikke være tomt.",
  "form_field.optional": "(valgfri)",
  "getting_started.heading": "Startmenu",
  "hashtag.admin_moderation": "Åbn modereringsbrugerflade for #{name}",
  "hashtag.browse": "Gennemse indlæg i #{hashtag}",
  "hashtag.browse_from_account": "Gennemse indlæg fra @{name} i #{hashtag}",
  "hashtag.column_header.tag_mode.all": "og {additional}",
  "hashtag.column_header.tag_mode.any": "eller {additional}",
  "hashtag.column_header.tag_mode.none": "uden {additional}",
  "hashtag.column_settings.select.no_options_message": "Ingen forslag fundet",
  "hashtag.column_settings.select.placeholder": "Angiv hashtags…",
  "hashtag.column_settings.tag_mode.all": "Alle disse",
  "hashtag.column_settings.tag_mode.any": "Nogle af disse",
  "hashtag.column_settings.tag_mode.none": "Ingen af disse",
  "hashtag.column_settings.tag_toggle": "Inkludér ekstra tags for denne kolonne",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} deltager} other {{counter} deltagere}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} indlæg} other {{counter} indlæg}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} indlæg} other {{counter} indlæg}} i dag",
  "hashtag.feature": "Fremhæv på profil",
  "hashtag.follow": "Følg hashtag",
  "hashtag.mute": "Skjul #{hashtag}",
  "hashtag.unfeature": "Fremhæv ikke på profil",
  "hashtag.unfollow": "Følg ikke længere hashtag",
  "hashtags.and_other": "…og {count, plural, one {}other {# flere}}",
  "hints.profiles.followers_may_be_missing": "Der kan mangle følgere for denne profil.",
  "hints.profiles.follows_may_be_missing": "Fulgte kan mangle for denne profil.",
  "hints.profiles.posts_may_be_missing": "Nogle indlæg kan mangle for denne profil.",
  "hints.profiles.see_more_followers": "Se flere følgere på {domain}",
  "hints.profiles.see_more_follows": "Se flere fulgte på {domain}",
  "hints.profiles.see_more_posts": "Se flere indlæg på {domain}",
  "home.column_settings.show_quotes": "Vis citater",
  "home.column_settings.show_reblogs": "Vis fremhævelser",
  "home.column_settings.show_replies": "Vis svar",
  "home.hide_announcements": "Skjul bekendtgørelser",
  "home.pending_critical_update.body": "Opdatér din Mastodon-server snarest muligt!",
  "home.pending_critical_update.link": "Se opdateringer",
  "home.pending_critical_update.title": "Kritisk sikkerhedsopdatering tilgængelig!",
  "home.show_announcements": "Vis bekendtgørelser",
  "ignore_notifications_modal.bots_title": "Ignorér notifikationer fra bots?",
  "ignore_notifications_modal.disclaimer": "Mastodon kan ikke informere brugere om, at du har ignoreret deres notifikationer. At ignorere notifikationer forhindrer ikke selve beskederne i at blive sendt.",
  "ignore_notifications_modal.filter_instead": "Filtrér i stedet",
  "ignore_notifications_modal.filter_to_act_users": "Du vil stadig kunne acceptere, afvise eller anmelde brugere",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtrering medvirker til at undgå potentiel forvirring",
  "ignore_notifications_modal.filter_to_review_separately": "Du kan gennemgå filtrerede notifikationer separat",
  "ignore_notifications_modal.ignore": "Ignorér notifikationer",
  "ignore_notifications_modal.limited_accounts_title": "Ignorér notifikationer fra modererede konti?",
  "ignore_notifications_modal.new_accounts_title": "Ignorér notifikationer fra nye konti?",
  "ignore_notifications_modal.not_followers_title": "Ignorér notifikationer fra folk, som ikke er følgere?",
  "ignore_notifications_modal.not_following_title": "Ignorér notifikationer fra folk, du ikke følger?",
  "ignore_notifications_modal.private_mentions_title": "Ignorér notifikationer fra uopfordrede private omtaler?",
  "info_button.label": "Hjælp",
  "info_button.what_is_alt_text": "<h1>Hvad er alt-tekst?</h1> <p>Alt-tekst leverer billedbeskrivelser til folk med synsnedsættelser, lav båndbredde-forbindelser eller med ønske om ekstra kontekst.</p> <p>Tilgængelighed og forståelse kan forbedres for alle ved at skrive klar, kortfattet og objektiv alt-tekst.</p> <ul> <li>Fang vigtige elementer</li> <li>Opsummér tekst i billeder</li> <li>Brug almindelig sætningsstruktur</li> <li>Undgå overflødig information</li> <li>Fokusér på tendenser og centrale resultater i kompleks grafik (såsom diagrammer eller kort)</li> </ul>",
  "interaction_modal.action": "For at interagere med {name}'s indlæg skal du logge ind på din konto på den Mastodon-server, du bruger.",
  "interaction_modal.action_follow": "For at følge {name} skal du logge ind på din konto på den Mastodon-server, du bruger.",
  "interaction_modal.go": "Gå",
  "interaction_modal.no_account_yet": "Har endnu ingen konto?",
  "interaction_modal.on_another_server": "På en anden server",
  "interaction_modal.on_this_server": "På denne server",
  "interaction_modal.title": "Log ind for at fortsætte",
  "interaction_modal.username_prompt": "F.eks. {example}",
  "intervals.full.days": "{number, plural, one {# dag} other {# dage}}",
  "intervals.full.hours": "{number, plural, one {# time} other {# timer}}",
  "intervals.full.minutes": "{number, plural, one {# minut} other {# minutter}}",
  "keyboard_shortcuts.back": "Gå tilbage",
  "keyboard_shortcuts.blocked": "Åbn listen over blokerede brugere",
  "keyboard_shortcuts.boost": "Fremhæv indlæg",
  "keyboard_shortcuts.column": "Fokusér kolonne",
  "keyboard_shortcuts.compose": "Fokusér skriveområdet",
  "keyboard_shortcuts.description": "Beskrivelse",
  "keyboard_shortcuts.direct": "Åbn kolonne med private omtaler",
  "keyboard_shortcuts.down": "Flyt nedad på listen",
  "keyboard_shortcuts.enter": "Åbn indlæg",
  "keyboard_shortcuts.explore": "Åbn trender-tidslinjen",
  "keyboard_shortcuts.favourite": "Føj indlæg til favoritter",
  "keyboard_shortcuts.favourites": "Åbn favoritlisten",
  "keyboard_shortcuts.federated": "Åbn fødereret tidslinje",
  "keyboard_shortcuts.heading": "Tastaturgenveje",
  "keyboard_shortcuts.home": "Åbn hjem-tidslinje",
  "keyboard_shortcuts.hotkey": "Hurtigtast",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Backspace",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Side ned",
  "keyboard_shortcuts.keys.page_up": "Side op",
  "keyboard_shortcuts.legend": "Vis dette symbol",
  "keyboard_shortcuts.load_more": "Fokusér knappen \"Indlæs flere\"",
  "keyboard_shortcuts.local": "Åbn lokal tidslinje",
  "keyboard_shortcuts.mention": "Omtal forfatter",
  "keyboard_shortcuts.muted": "Åbn listen over skjulte brugere",
  "keyboard_shortcuts.my_profile": "Åbn din profil",
  "keyboard_shortcuts.notifications": "for at åbne notifikationskolonnen",
  "keyboard_shortcuts.open_media": "Åbn medier",
  "keyboard_shortcuts.pinned": "Åbn liste over fastgjorte indlæg",
  "keyboard_shortcuts.profile": "Åbn forfatters profil",
  "keyboard_shortcuts.quote": "Citér indlæg",
  "keyboard_shortcuts.reply": "Besvar indlæg",
  "keyboard_shortcuts.requests": "Åbn liste over følgeanmodninger",
  "keyboard_shortcuts.search": "Fokusér søgebjælke",
  "keyboard_shortcuts.spoilers": "Vis/skjul indholdsadvarsel-felt",
  "keyboard_shortcuts.start": "Åbn \"komme i gang\"-kolonne",
  "keyboard_shortcuts.toggle_hidden": "Vis/skjul tekst bag indholdsadvarsel",
  "keyboard_shortcuts.toggle_sensitivity": "Vis/skjul medier",
  "keyboard_shortcuts.toot": "Påbegynd nyt indlæg",
  "keyboard_shortcuts.top": "Flyt til toppen af listen",
  "keyboard_shortcuts.translate": "Oversæt et indlæg",
  "keyboard_shortcuts.unfocus": "Fjern fokus fra tekstskrivningsområde/søgning",
  "keyboard_shortcuts.up": "Flyt opad på listen",
  "learn_more_link.got_it": "Forstået",
  "learn_more_link.learn_more": "Få mere at vide",
  "lightbox.close": "Luk",
  "lightbox.next": "Næste",
  "lightbox.previous": "Forrige",
  "lightbox.zoom_in": "Zoom til faktisk størrelse",
  "lightbox.zoom_out": "Zoom for at tilpasse",
  "limited_account_hint.action": "Vis profil alligevel",
  "limited_account_hint.title": "Denne profil eller server er blevet skjult af moderatorerne på {domain}.",
  "link_preview.author": "Af {name}",
  "link_preview.more_from_author": "Mere fra {name}",
  "link_preview.shares": "{count, plural, one {{counter} indlæg} other {{counter} indlæg}}",
  "lists.add_member": "Tilføj",
  "lists.add_to_list": "Føj til liste",
  "lists.add_to_lists": "Føj {name} til lister",
  "lists.create": "Opret",
  "lists.create_a_list_to_organize": "Opret en ny liste til organisering af dit Hjem-feed",
  "lists.create_list": "Opret liste",
  "lists.delete": "Slet liste",
  "lists.done": "Færdig",
  "lists.edit": "Redigér liste",
  "lists.exclusive": "Skjul medlemmer i Hjem",
  "lists.exclusive_hint": "Hvis nogen er på denne liste, så skjul dem i hjem-feed for at undgå at se deres indlæg to gange.",
  "lists.find_users_to_add": "Find brugere at tilføje",
  "lists.list_members_count": "{count, plural, one {# medlem} other {# medlemmer}}",
  "lists.list_name": "Listetitel",
  "lists.new_list_name": "Ny listetitel",
  "lists.no_lists_yet": "Ingen lister endnu.",
  "lists.no_members_yet": "Ingen medlemmer endnu.",
  "lists.no_results_found": "Ingen resultater fundet.",
  "lists.remove_member": "Fjern",
  "lists.replies_policy.followed": "Enhver bruger, der følges",
  "lists.replies_policy.list": "Listemedlemmer",
  "lists.replies_policy.none": "Ingen",
  "lists.save": "Gem",
  "lists.search": "Søg",
  "lists.show_replies_to": "Medtag svar fra listemedlemmer til",
  "load_pending": "{count, plural, one {# nyt element} other {# nye elementer}}",
  "loading_indicator.label": "Indlæser…",
  "media_gallery.hide": "Skjul",
  "moved_to_account_banner.text": "Din konto {disabledAccount} er i øjeblikket deaktiveret, fordi du er flyttet til {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Skjul fra notifikationer",
  "mute_modal.hide_options": "Skjul valgmuligheder",
  "mute_modal.indefinite": "Indtil jeg vælger at se dem igen",
  "mute_modal.show_options": "Vis valgmuligheder",
  "mute_modal.they_can_mention_and_follow": "Vedkommende kan nævne og følge dig, men vil ikke blive vist.",
  "mute_modal.they_wont_know": "De vil ikke vide, at de er blevet skjult.",
  "mute_modal.title": "Skjul bruger?",
  "mute_modal.you_wont_see_mentions": "Indlæg, som nævner vedkommende, vises ikke.",
  "mute_modal.you_wont_see_posts": "De kan stadig se dine indlæg, men du vil ikke se deres.",
  "navigation_bar.about": "Om",
  "navigation_bar.account_settings": "Adgangskode og sikkerhed",
  "navigation_bar.administration": "Administration",
  "navigation_bar.advanced_interface": "Åbn i avanceret netgrænseflade",
  "navigation_bar.automated_deletion": "Automatiseret sletning af indlæg",
  "navigation_bar.blocks": "Blokerede brugere",
  "navigation_bar.bookmarks": "Bogmærker",
  "navigation_bar.collections": "Samlinger",
  "navigation_bar.direct": "Private omtaler",
  "navigation_bar.domain_blocks": "Blokerede domæner",
  "navigation_bar.favourites": "Favoritter",
  "navigation_bar.filters": "Skjulte ord",
  "navigation_bar.follow_requests": "Følgeanmodninger",
  "navigation_bar.followed_tags": "Hashtags, som følges",
  "navigation_bar.follows_and_followers": "Følger og følgere",
  "navigation_bar.import_export": "Import og eksport",
  "navigation_bar.lists": "Lister",
  "navigation_bar.live_feed_local": "Live feed (lokalt)",
  "navigation_bar.live_feed_public": "Live feed (offentligt)",
  "navigation_bar.logout": "Log af",
  "navigation_bar.main": "Primær",
  "navigation_bar.moderation": "Moderering",
  "navigation_bar.more": "Mere",
  "navigation_bar.mutes": "Skjulte brugere",
  "navigation_bar.opened_in_classic_interface": "Indlæg, konti og visse andre sider åbnes som standard i den klassiske webgrænseflade.",
  "navigation_bar.preferences": "Præferencer",
  "navigation_bar.privacy_and_reach": "Fortrolighed og rækkevidde",
  "navigation_bar.search": "Søg",
  "navigation_bar.search_trends": "Søg/Trender",
  "navigation_panel.collapse_followed_tags": "Sammenfold menuen Fulgte hashtags",
  "navigation_panel.collapse_lists": "Luk listemenu",
  "navigation_panel.expand_followed_tags": "Udfold menuen Fulgte hashtags",
  "navigation_panel.expand_lists": "Udvid listemenu",
  "not_signed_in_indicator.not_signed_in": "Du skal logge ind for at tilgå denne ressource.",
  "notification.added_to_collection": "{name} tilføjede dig til en samling",
  "notification.admin.report": "{name} anmeldte {target}",
  "notification.admin.report_account": "{name} anmeldte {count, plural, one {et indlæg} other {# indlæg}} fra {target} angående {category}",
  "notification.admin.report_account_other": "{name} anmeldte {count, plural, one {et indlæg} other {# indlæg}} fra {target}",
  "notification.admin.report_statuses": "{name} anmeldte {target} angående {category}",
  "notification.admin.report_statuses_other": "{name} anmeldte {target}",
  "notification.admin.sign_up": "{name} tilmeldte sig",
  "notification.admin.sign_up.name_and_others": "{name} og {count, plural, one {# anden} other {# andre}} tilmeldte sig",
  "notification.annual_report.message": "Din {year} #Wrapstodon venter! Afslør årets højdepunkter og mindeværdige øjeblikke på Mastodon!",
  "notification.annual_report.view": "Vis #Wrapstodon",
  "notification.collection_update": "{name} redigerede en samling, du er med i",
  "notification.favourite": "{name} føjede dit indlæg til favoritter",
  "notification.favourite.name_and_others_with_link": "{name} og <a>{count, plural, one {# anden} other {# andre}}</a> føjede dit indlæg til favoritter",
  "notification.favourite_pm": "{name} føjede din private omtale til favoritter",
  "notification.favourite_pm.name_and_others_with_link": "{name} og <a>{count, plural, one {# anden} other {# andre}}</a> føjede dit indlæg til favoritter",
  "notification.follow": "{name} begyndte at følge dig",
  "notification.follow.name_and_others": "{name} og <a>{count, plural, one {# andre} other {# andre}}</a> begyndte at følge dig",
  "notification.follow_request": "{name} har anmodet om at følge dig",
  "notification.follow_request.name_and_others": "{name} og {count, plural, one {# anden} other {# andre}} har anmodet om at følger dig",
  "notification.label.mention": "Omtale",
  "notification.label.private_mention": "Privat omtale",
  "notification.label.private_reply": "Privat svar",
  "notification.label.quote": "{name} citerede dit indlæg",
  "notification.label.reply": "Svar",
  "notification.mention": "Omtale",
  "notification.mentioned_you": "{name} omtalte dig",
  "notification.moderation-warning.learn_more": "Læs mere",
  "notification.moderation_warning": "Du har fået en moderationsadvarsel",
  "notification.moderation_warning.action_delete_statuses": "Nogle af dine indlæg er blevet fjernet.",
  "notification.moderation_warning.action_disable": "Din konto er blevet deaktiveret.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Nogle af dine indlæg er blevet markeret som følsomme.",
  "notification.moderation_warning.action_none": "Din konto har fået en moderationsadvarsel.",
  "notification.moderation_warning.action_sensitive": "Dine indlæg markeres fra nu af som følsomme.",
  "notification.moderation_warning.action_silence": "Din konto er blevet begrænset.",
  "notification.moderation_warning.action_suspend": "Din konto er blevet suspenderet.",
  "notification.own_poll": "Din afstemning er afsluttet",
  "notification.poll": "En afstemning, hvori du har stemt, er slut",
  "notification.quoted_update": "{name} redigerede et indlæg, du har citeret",
  "notification.reblog": "{name} fremhævede dit indlæg",
  "notification.reblog.name_and_others_with_link": "{name} og <a>{count, plural, one {# anden} other {# andre}}</a> fremhævede dit indlæg",
  "notification.relationships_severance_event": "Mistede forbindelser med {name}",
  "notification.relationships_severance_event.account_suspension": "En admin fra {from} har suspenderet {target}, så du kan ikke længere få opdateringer fra eller interagere med dem.",
  "notification.relationships_severance_event.domain_block": "En admin fra {from} har blokeret {target}, herunder {followersCount} følgere og {followingCount, plural, one {# konto, der} other {# konti, som}} som du følger.",
  "notification.relationships_severance_event.learn_more": "Læs mere",
  "notification.relationships_severance_event.user_domain_block": "Du har blokeret {target}. {followersCount} af dine følgere samt {followingCount, plural, one {# konto, der} other {# konti, som}} du følger, er hermed fjernet.",
  "notification.status": "{name} har netop slået noget op",
  "notification.update": "{name} redigerede et indlæg",
  "notification_requests.accept": "Acceptér",
  "notification_requests.accept_multiple": "{count, plural, one {Acceptér # anmodning…} other {Acceptér # anmodninger…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Acceptér anmodning} other {Acceptér anmodninger}}",
  "notification_requests.confirm_accept_multiple.message": "Du er ved at acceptere {count, plural, one {en notifikationsanmodning} other {# notifikationsanmodninger}}. Er du sikker på, at du vil fortsætte?",
  "notification_requests.confirm_accept_multiple.title": "Acceptér notifikationsanmodninger?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Afvis anmodning} other {Afvis anmodninger}}",
  "notification_requests.confirm_dismiss_multiple.message": "Du er ved at afvise {count, plural, one {en notifikationsanmodning} other {# notifikationsanmodninger}}. Du vil derfor ikke nemt kunne tilgå {count, plural, one {den} other {dem}} igen. Er du sikker på, at du vil fortsætte?",
  "notification_requests.confirm_dismiss_multiple.title": "Afvis notifikationsanmodninger?",
  "notification_requests.dismiss": "Afvis",
  "notification_requests.dismiss_multiple": "{count, plural, one {Afvis # anmodning…} other {Afvis # anmodninger…}}",
  "notification_requests.edit_selection": "Redigér",
  "notification_requests.exit_selection": "Udført",
  "notification_requests.explainer_for_limited_account": "Notifikationer fra denne konto er blevet filtreret, da kontoen er pålagt restriktioner af en moderator.",
  "notification_requests.explainer_for_limited_remote_account": "Notifikationer fra denne konto er blevet filtreret, da kontoen eller dens server er pålagt restriktioner af en moderator.",
  "notification_requests.maximize": "Maksimér",
  "notification_requests.minimize_banner": "Minimér filtrerede notifikationsbanner",
  "notification_requests.notifications_from": "Notifikationer fra {name}",
  "notification_requests.title": "Filtrerede notifikationer",
  "notification_requests.view": "Vis notifikationer",
  "notifications.clear": "Ryd notifikationer",
  "notifications.clear_confirmation": "Er du sikker på, at du vil rydde alle dine notifikationer permanent?",
  "notifications.clear_title": "Ryd notifikationer?",
  "notifications.column_settings.admin.report": "Nye rapporteringer:",
  "notifications.column_settings.admin.sign_up": "Nye tilmeldinger:",
  "notifications.column_settings.alert": "Computernotifikationer",
  "notifications.column_settings.collections": "Samlinger:",
  "notifications.column_settings.favourite": "Favoritter:",
  "notifications.column_settings.filter_bar.advanced": "Vis alle kategorier",
  "notifications.column_settings.filter_bar.category": "Hurtigfiltreringsbjælke",
  "notifications.column_settings.follow": "Nye følgere:",
  "notifications.column_settings.follow_request": "Nye følgeanmodninger:",
  "notifications.column_settings.group": "Gruppér",
  "notifications.column_settings.mention": "Omtaler:",
  "notifications.column_settings.poll": "Afstemningsresultater:",
  "notifications.column_settings.push": "Push-notifikationer",
  "notifications.column_settings.quote": "Citater:",
  "notifications.column_settings.reblog": "Fremhævelser:",
  "notifications.column_settings.show": "Vis i kolonne",
  "notifications.column_settings.sound": "Afspil lyd",
  "notifications.column_settings.status": "Nye indlæg:",
  "notifications.column_settings.unread_notifications.category": "Ulæste notifikationer",
  "notifications.column_settings.unread_notifications.highlight": "Fremhæv ulæste notifikationer",
  "notifications.column_settings.update": "Redigeringer:",
  "notifications.filter.all": "Alle",
  "notifications.filter.boosts": "Fremhævelser",
  "notifications.filter.collections": "Samlinger",
  "notifications.filter.favourites": "Favoritter",
  "notifications.filter.follows": "Følger",
  "notifications.filter.mentions": "Omtaler",
  "notifications.filter.polls": "Afstemningsresultater",
  "notifications.filter.statuses": "Opdateringer fra personer, du følger",
  "notifications.grant_permission": "Tildel tilladelse.",
  "notifications.group": "{count} notifikationer",
  "notifications.mark_as_read": "Markér alle notifikationer som læst",
  "notifications.permission_denied": "Computernotifikationer er utilgængelige grundet tidligere afvist netlæser-tilladelsesanmodning",
  "notifications.permission_denied_alert": "Computernotifikationer kan ikke aktiveres, da netlæser-tilladelse tidligere blev nægtet",
  "notifications.permission_required": "Computernotifikationer er utilgængelige, da den krævede tilladelse ikke er tildelt.",
  "notifications.policy.accept": "Acceptér",
  "notifications.policy.accept_hint": "Vis notifikationer",
  "notifications.policy.drop": "Ignorér",
  "notifications.policy.drop_hint": "Send til intetheden, for aldrig at blive set igen",
  "notifications.policy.filter": "Filter",
  "notifications.policy.filter_bots_hint": "Konti markeret som automatiseret",
  "notifications.policy.filter_bots_title": "Bots",
  "notifications.policy.filter_hint": "Send til filtrerede notifikationsindbakke",
  "notifications.policy.filter_limited_accounts_hint": "Begrænset af servermoderatorer",
  "notifications.policy.filter_limited_accounts_title": "Modererede konti",
  "notifications.policy.filter_new_accounts.hint": "Oprettet indenfor {days, plural, one {den seneste dag} other {de seneste # dage}}",
  "notifications.policy.filter_new_accounts_title": "Nye konti",
  "notifications.policy.filter_not_followers_hint": "Inklusiv personer, som har fulgt dig {days, plural, one {mindre end én dag} other {mindre end # dage}}",
  "notifications.policy.filter_not_followers_title": "Personer, som ikke følger dig",
  "notifications.policy.filter_not_following_hint": "Indtil du manuelt godkender dem",
  "notifications.policy.filter_not_following_title": "Personer, du ikke følger",
  "notifications.policy.filter_private_mentions_hint": "Filtreret, medmindre det er et svar på din egen omtale, eller hvis du følger afsenderen",
  "notifications.policy.filter_private_mentions_title": "Uopfordrede private omtaler",
  "notifications.policy.title": "Håndtér notifikationer fra…",
  "notifications_permission_banner.enable": "Aktivér computernotifikationer",
  "notifications_permission_banner.how_to_control": "Aktivér computernotifikationer for at få besked, når Mastodon ikke er åben. Når de er aktiveret, kan man via knappen {icon} ovenfor præcist styre, hvilke typer af interaktioner, som genererer computernotifikationer.",
  "notifications_permission_banner.title": "Gå aldrig glip af noget",
  "onboarding.follows.back": "Tilbage",
  "onboarding.follows.empty": "Ingen resultater tilgængelige pt. Prøv at bruge søgning eller gennemse siden for at finde personer at følge, eller forsøg igen senere.",
  "onboarding.follows.next": "Næste: Opsætning af din profil",
  "onboarding.follows.search": "Søg",
  "onboarding.follows.title": "Følg folk for at komme i gang",
  "onboarding.profile.discoverable": "Gør min profil synlig",
  "onboarding.profile.discoverable_hint": "Når du vælger at være synlig på Mastodon, kan dine indlæg blive vist i søgeresultater og trender, og din profil kan blive foreslået til personer med samme interesser som dig.",
  "onboarding.profile.display_name": "Vist navn",
  "onboarding.profile.display_name_hint": "Dit fulde navn eller dit sjove navn…",
  "onboarding.profile.finish": "Afslut",
  "onboarding.profile.note": "Bio",
  "onboarding.profile.note_hint": "Du kan @omtale andre personer eller #hashtags…",
  "onboarding.profile.title": "Profilopsætning",
  "onboarding.profile.upload_avatar": "Upload profilbillede",
  "onboarding.profile.upload_header": "Upload profilbanner",
  "password_confirmation.exceeds_maxlength": "Adgangskodebekræftelse overstiger maks. adgangskodelængde",
  "password_confirmation.mismatching": "Adgangskodebekræftelse matcher ikke",
  "picture_in_picture.restore": "Indsæt det igen",
  "poll.closed": "Lukket",
  "poll.refresh": "Genindlæs",
  "poll.reveal": "Se resultater",
  "poll.total_people": "{count, plural, one {# person} other {# personer}}",
  "poll.total_votes": "{count, plural, one {# stemme} other {# stemmer}}",
  "poll.vote": "Stem",
  "poll.voted": "Du stemte på dette svar",
  "poll.votes": "{votes, plural, one {# stemme} other {# stemmer}}",
  "poll_button.add_poll": "Tilføj en afstemning",
  "poll_button.remove_poll": "Fjern afstemning",
  "privacy.change": "Tilpas indlægsfortrolighed",
  "privacy.direct.long": "Alle omtalt i indlægget",
  "privacy.direct.short": "Privat omtale",
  "privacy.private.long": "Kun dine følgere",
  "privacy.private.short": "Følgere",
  "privacy.public.long": "Alle på og udenfor Mastodon",
  "privacy.public.short": "Offentlig",
  "privacy.quote.anyone": "{visibility}, citering tilladt",
  "privacy.quote.disabled": "{visibility}, citering deaktiveret",
  "privacy.quote.limited": "{visibility}, citering begrænset",
  "privacy.unlisted.additional": "Dette svarer til offentlig, bortset fra at indlægget ikke vises i live-feeds eller hashtags, udforsk eller Mastodon-søgning, selvom du har tilvalgt dette for kontoen.",
  "privacy.unlisted.long": "Skjult fra Mastodons søgeresultater, trender og offentlige tidslinjer",
  "privacy.unlisted.short": "Offentlig (stille)",
  "privacy_policy.last_updated": "Senest opdateret {date}",
  "privacy_policy.title": "Privatlivspolitik",
  "quote_error.edit": "Citater kan ikke tilføjes ved redigering af et indlæg.",
  "quote_error.poll": "Citering er ikke tilladt med afstemninger.",
  "quote_error.private_mentions": "Citering er ikke tilladt med direkte omtaler.",
  "quote_error.quote": "Kun ét citat ad gangen er tilladt.",
  "quote_error.unauthorized": "Du har ikke tilladelse til at citere dette indlæg.",
  "quote_error.upload": "Citering ikke tilladt ved medievedhæftninger.",
  "recommended": "Anbefalet",
  "refresh": "Genindlæs",
  "regeneration_indicator.please_stand_by": "Vent venligst.",
  "regeneration_indicator.preparing_your_home_feed": "Forbereder dit hjem-feed…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# dag} other {# dage}} siden",
  "relative_time.full.hours": "{number, plural, one {# time} other {# timer}} siden",
  "relative_time.full.just_now": "netop nu",
  "relative_time.full.minutes": "{number, plural, one {# minut} other {# minutter}} siden",
  "relative_time.full.seconds": "{number, plural, one {# sekund} other {# sekunder}} siden",
  "relative_time.hours": "{number}t",
  "relative_time.just_now": "nu",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "i dag",
  "remove_quote_hint.button_label": "Forstået",
  "remove_quote_hint.message": "Du kan gøre dette fra menuen {icon} indstillinger.",
  "remove_quote_hint.title": "Vil du fjerne dit citerede indlæg?",
  "reply_indicator.attachments": "{count, plural, one {# vedhæftning} other {# vedhæftninger}}",
  "reply_indicator.cancel": "Afbryd",
  "reply_indicator.poll": "Afstemning",
  "report.block": "Blokér",
  "report.block_explanation": "Du vil ikke se vedkommendes indlæg. Vedkommende vil ikke kunne se dine indlæg eller følge dig. Vedkommende vil kunne se, at de er blokeret.",
  "report.categories.legal": "Juridisk",
  "report.categories.other": "Andre",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Indhold overtræder en eller flere serverregler",
  "report.category.subtitle": "Vælg den bedste match",
  "report.category.title_account": "Fortæl os, hvad der foregår med denne profil",
  "report.category.title_collection": "Fortæl os, hvad der foregår med denne samling",
  "report.category.title_status": "Fortæl os, hvad der foregår med dette indlæg",
  "report.close": "Udført",
  "report.comment.title": "Er der andet, som vi bør vide?",
  "report.forward": "Videresend til {target}",
  "report.forward_hint": "Kontoen er fra en anden server. Send også en anonymiseret kopi af anmeldelsen dertil?",
  "report.mute": "Skjul",
  "report.mute_explanation": "Du vil ikke se deres indlæg. De kan stadig se dine indlæg og følge dig. De vil ikke kunne se, at de er blevet skjult.",
  "report.next": "Næste",
  "report.placeholder": "Yderligere kommentarer",
  "report.reasons.dislike": "Jeg bryder mig ikke om det",
  "report.reasons.dislike_description": "Det er ikke noget, du ønsker at se",
  "report.reasons.legal": "Det er ulovligt",
  "report.reasons.legal_description": "Du mener, at det er i strid med lovgivningen i dit eller serverens land",
  "report.reasons.other": "Det er noget andet",
  "report.reasons.other_description": "Problemet passer ikke ind i andre kategorier",
  "report.reasons.spam": "Det er spam",
  "report.reasons.spam_description": "Ondsindede links, falsk engagement eller repetitive svar",
  "report.reasons.violation": "Overtræder serverregler",
  "report.reasons.violation_description": "Det står klart, at det bryder bestemte regler",
  "report.rules.subtitle": "Vælg alle relevante",
  "report.rules.title": "Hvilke regler overtrædes?",
  "report.statuses.subtitle": "Vælg alle relevante",
  "report.statuses.title": "Er der indlæg, som kan bekræfte denne anmeldelse?",
  "report.submission_error": "Anmeldelse kunne ikke indsendes",
  "report.submission_error_details": "Tjek din netværksforbindelse eller prøv igen senere.",
  "report.submit": "Indsend",
  "report.target": "Anmelder {target}",
  "report.thanks.take_action": "Her er mulighederne for at styre, hvad du ser på Mastodon:",
  "report.thanks.take_action_actionable": "Mens dette gennemgås, kan der skrides til handling mod @{name}:",
  "report.thanks.title": "Ønsker ikke at se dette?",
  "report.thanks.title_actionable": "Tak for anmeldelsen, der vil blive set nærmere på dette.",
  "report.unfollow": "Følg ikke længere @{name}",
  "report.unfollow_explanation": "Du følger denne konto. Hvis du ikke længere vil se vedkommendes indlæg i dit hjem-feed, så stop med at følge dem.",
  "report_notification.attached_statuses": "{count, plural, one {{count} indlæg} other {{count} indlæg}} vedhæftet",
  "report_notification.categories.legal": "Juridisk",
  "report_notification.categories.legal_sentence": "ikke-tilladt indhold",
  "report_notification.categories.other": "Andre",
  "report_notification.categories.other_sentence": "andet",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Regelovertrædelse",
  "report_notification.categories.violation_sentence": "regelovertrædelse",
  "report_notification.open": "Åbn anmeldelse",
  "search.clear": "Ryd søgning",
  "search.no_recent_searches": "Ingen seneste søgninger",
  "search.placeholder": "Søg",
  "search.quick_action.account_search": "Profiler matchende {x}",
  "search.quick_action.go_to_account": "Gå til profilen {x}",
  "search.quick_action.go_to_hashtag": "Gå til hashtagget {x}",
  "search.quick_action.open_url": "Åbn URL i Mastodon",
  "search.quick_action.status_search": "Indlæg matchende {x}",
  "search.search_or_paste": "Søg eller indsæt URL",
  "search_popout.full_text_search_disabled_message": "Utilgængelig på {domain}.",
  "search_popout.full_text_search_logged_out_message": "Kun tilgængelig, når logget ind.",
  "search_popout.language_code": "ISO-sprogkode",
  "search_popout.options": "Søgevalg",
  "search_popout.quick_actions": "Hurtige handlinger",
  "search_popout.recent": "Seneste søgninger",
  "search_popout.specific_date": "bestemt dato",
  "search_popout.user": "bruger",
  "search_results.accounts": "Profiler",
  "search_results.all": "Alle",
  "search_results.collections": "Samlinger",
  "search_results.hashtags": "Hashtags",
  "search_results.no_results": "Ingen resultater.",
  "search_results.no_search_yet": "Prøv at søge efter indlæg, profiler eller hashtags.",
  "search_results.see_all": "Vis alle",
  "search_results.statuses": "Indlæg",
  "search_results.title": "Søg efter \"{q}\"",
  "server_banner.about_active_users": "Personer, som brugte denne server de seneste 30 dage (månedlige aktive brugere)",
  "server_banner.active_users": "aktive brugere",
  "server_banner.administered_by": "Administreret af:",
  "server_banner.is_one_of_many": "{domain} er en af de mange uafhængige Mastodon-servere, du kan bruge for at deltage i fediverset.",
  "server_banner.more_about_this_server": "Mere om denne server",
  "server_banner.server_stats": "Serverstatstik:",
  "sign_in_banner.create_account": "Opret konto",
  "sign_in_banner.follow_anyone": "Følg alle på tværs af fediverset og se alt i kronologisk rækkefølge. Ingen algoritmer, annoncer eller clickbait i syne.",
  "sign_in_banner.mastodon_is": "Mastodon er den bedste måde at holde sig ajour med, hvad der sker.",
  "sign_in_banner.sign_in": "Log ind",
  "sign_in_banner.sso_redirect": "Log ind eller Tilmeld",
  "skip_links.hotkey": "<span>Genvejstast</span> {hotkey}",
  "skip_links.skip_to_content": "Gå til hovedindholdet",
  "skip_links.skip_to_navigation": "Gå til hovednavigation",
  "status.admin_account": "Åbn modereringsbrugerflade for @{name}",
  "status.admin_domain": "Åbn modereringsbrugerflade for {domain}",
  "status.admin_status": "Åbn dette indlæg i modereringsbrugerfladen",
  "status.all_disabled": "Fremhævelser og citater er deaktiveret",
  "status.block": "Blokér @{name}",
  "status.bookmark": "Bogmærk",
  "status.cancel_reblog_private": "Fjern fremhævelse",
  "status.cannot_edit": "Du har ikke tilladelse til at redigere dette indlæg",
  "status.cannot_quote": "Du har ikke tilladelse til at citere dette indlæg",
  "status.cannot_reblog": "Dette indlæg kan ikke fremhæves",
  "status.contains_quote": "Indeholder citat",
  "status.context.loading": "Indlæser flere svar",
  "status.context.loading_error": "Kunne ikke indlæse nye svar",
  "status.context.loading_success": "Nye svar indlæst",
  "status.context.more_replies_found": "Flere svar fundet",
  "status.context.retry": "Prøv igen",
  "status.context.show": "Vis",
  "status.continued_thread": "Fortsat tråd",
  "status.copy": "Kopiér link til indlæg",
  "status.delete": "Slet",
  "status.delete.success": "Indlæg slettet",
  "status.detailed_status": "Detaljeret samtalevisning",
  "status.direct": "Nævn @{name} privat",
  "status.direct_indicator": "Privat omtale",
  "status.edit": "Redigér",
  "status.edited": "Senest redigeret {date}",
  "status.edited_x_times": "Redigeret {count, plural, one {{count} gang} other {{count} gange}}",
  "status.embed": "Hent indlejringskode",
  "status.favourite": "Favoritmarkér",
  "status.favourites_count": "{count, plural, one {{counter} favorit} other {{counter} favoritter}}",
  "status.filter": "Filtrér dette indlæg",
  "status.history.created": "{name} oprettet {date}",
  "status.history.edited": "{name} redigeret {date}",
  "status.load_more": "Indlæs mere",
  "status.media.open": "Klik for at åbne",
  "status.media.show": "Klik for at vise",
  "status.media_hidden": "Medie skjult",
  "status.mention": "Nævn @{name}",
  "status.more": "Mere",
  "status.mute": "Skjul @{name}",
  "status.mute_conversation": "Skjul samtale",
  "status.not_quoted": "Du er ikke citeret i dette indlæg",
  "status.open": "Udvid dette indlæg",
  "status.pin": "Fastgør til profil",
  "status.public_only": "Dette indlæg er privat",
  "status.quote": "Citér",
  "status.quote.cancel": "Annullér citat",
  "status.quote_error.blocked_account_hint.title": "Dette indlæg er skjult, fordi du har blokeret @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Dette indlæg er skjult, fordi du har blokeret @{domain}.",
  "status.quote_error.filtered": "Skjult på grund af et af dine filtre",
  "status.quote_error.limited_account_hint.action": "Vis alligevel",
  "status.quote_error.limited_account_hint.title": "Denne profil er blevet skjult af {domain}-moderatorerne.",
  "status.quote_error.muted_account_hint.title": "Dette indlæg er skjult, fordi du har skjult @{name}.",
  "status.quote_error.not_available": "Indlæg utilgængeligt",
  "status.quote_error.pending_approval": "Afventende indlæg",
  "status.quote_error.pending_approval_popout.body": "På Mastodon kan du kontrollere, om nogen kan citere dig. Dette indlæg afventer, mens vi får den oprindelige forfatters godkendelse.",
  "status.quote_error.revoked": "Indlæg fjernet af forfatter",
  "status.quote_followers_only": "Kun følgere kan citere dette indlæg",
  "status.quote_manual_review": "Forfatter vil manuelt gennemgå",
  "status.quote_noun": "Citat",
  "status.quote_policy_change": "Ændr hvem der kan citere",
  "status.quote_post_author": "Citerede et indlæg fra @{name}",
  "status.quote_private": "Private indlæg kan ikke citeres",
  "status.quotes.empty": "Ingen har citeret dette indlæg endnu. Når det sker, vil det fremgå her.",
  "status.quotes.local_other_disclaimer": "Citater afvist af forfatteren vil ikke blive vist.",
  "status.quotes.remote_other_disclaimer": "Kun citater fra {domain} vises med garanti her. Citater afvist af forfatteren vil ikke blive vist.",
  "status.quotes_count": "{count, plural, one {{counter} citat} other {{counter} citater}}",
  "status.read_more": "Læs mere",
  "status.reblog": "Fremhæv",
  "status.reblog_or_quote": "Fremhæv eller citér",
  "status.reblog_private": "Del igen med dine følgere",
  "status.reblogged_by": "{name} fremhævede",
  "status.reblogs.empty": "Ingen har endnu fremhævet dette indlæg. Når nogen gør, vil det fremgå hér.",
  "status.reblogs_count": "{count, plural, one {{counter} fremhævelse} other {{counter} fremhævelser}}",
  "status.redraft": "Slet og omskriv",
  "status.remove_bookmark": "Fjern bogmærke",
  "status.remove_favourite": "Fjern fra favoritter",
  "status.remove_quote": "Fjern",
  "status.replied_in_thread": "Svarede i tråd",
  "status.replied_to": "Svarede {name}",
  "status.reply": "Besvar",
  "status.replyAll": "Svar alle",
  "status.report": "Anmeld @{name}",
  "status.request_quote": "Anmod om citeringsmulighed",
  "status.revoke_quote": "Fjern eget indlæg fra @{name}s indlæg",
  "status.sensitive_warning": "Følsomt indhold",
  "status.share": "Del",
  "status.show_less_all": "Vis mindre for alle",
  "status.show_more_all": "Vis mere for alle",
  "status.show_original": "Vis original",
  "status.title.with_attachments": "{user} postede {attachmentCount, plural, one {en vedhæftning} other {{attachmentCount} vedhæftninger}}",
  "status.translate": "Oversæt",
  "status.translated_from_with": "Oversat fra {lang} ved brug af {provider}",
  "status.uncached_media_warning": "Ingen forhåndsvisning",
  "status.unmute_conversation": "Vis samtale",
  "status.unpin": "Frigør fra profil",
  "subscribed_languages.lead": "Efter ændringen vises kun indlæg på de valgte sprog på din hjem- og listetidslinje. Vælger du ingen, vil du modtage indlæg på alle sprog.",
  "subscribed_languages.save": "Gem ændringer",
  "subscribed_languages.target": "Skift abonnementssprog for {target}",
  "tabs_bar.home": "Hjem",
  "tabs_bar.menu": "Menu",
  "tabs_bar.notifications": "Notifikationer",
  "tabs_bar.publish": "Nyt indlæg",
  "tabs_bar.quick_links": "Hurtig-links",
  "tabs_bar.search": "Søg",
  "tag.remove": "Fjern",
  "terms_of_service.effective_as_of": "Gældende pr. {date}",
  "terms_of_service.title": "Tjenestevilkår",
  "terms_of_service.upcoming_changes_on": "Kommende ændringer pr. {date}",
  "time_remaining.days": "{number, plural, one {# dag} other {# dage}} tilbage",
  "time_remaining.hours": "{number, plural, one {# time} other {# timer}} tilbage",
  "time_remaining.minutes": "{number, plural, one {# minut} other {# minutter}} tilbage",
  "time_remaining.moments": "Få øjeblikke tilbage",
  "time_remaining.seconds": "{number, plural, one {# sekund} other {# sekunder}} tilbage",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} personer}} {days, plural, one {den seneste dag} other {de seneste {days} dage}}",
  "trends.trending_now": "Trender lige nu",
  "ui.beforeunload": "Dit udkast går tabt, hvis du lukker Mastodon.",
  "units.short.billion": "{count} mia.",
  "units.short.million": "{count} mio.",
  "units.short.thousand": "{count} tusind",
  "upload_area.title": "Træk og slip for at uploade",
  "upload_button.label": "Tilføj billeder, en video- eller lydfil",
  "upload_error.limit": "Grænse for filupload nået.",
  "upload_error.poll": "Filupload ikke tilladt for afstemninger.",
  "upload_error.quote": "Fil-upload ikke tilladt i citater.",
  "upload_form.drag_and_drop.instructions": "For at opsamle en medievedhæftning, tryk på Mellemrum eller Retur. Mens der trækkes, benyt piletasterne til at flytte medievedhæftningen i en given retning. Tryk på Mellemrum eller Retur igen for at slippe medievedhæftningen på den nye position, eller tryk på Escape for at afbryde.",
  "upload_form.drag_and_drop.on_drag_cancel": "Træk blev afbrudt. Medievedhæftningen {item} blev sluppet.",
  "upload_form.drag_and_drop.on_drag_end": "Medievedhæftningen {item} er sluppet.",
  "upload_form.drag_and_drop.on_drag_over": "Medievedhæftningen {item} er flyttet.",
  "upload_form.drag_and_drop.on_drag_start": "Opsamlede medievedhæftningen {item}.",
  "upload_form.edit": "Redigér",
  "upload_progress.label": "Uploader...",
  "upload_progress.processing": "Behandler…",
  "username.taken": "Brugernavnet er taget. Prøv et andet",
  "video.close": "Luk video",
  "video.download": "Download fil",
  "video.exit_fullscreen": "Forlad fuldskærm",
  "video.expand": "Udvid video",
  "video.fullscreen": "Fuldskærm",
  "video.hide": "Skjul video",
  "video.mute": "Slå lyd fra",
  "video.pause": "Sæt på pause",
  "video.play": "Afspil",
  "video.skip_backward": "Overspring baglæns",
  "video.skip_forward": "Overspring fremad",
  "video.unmute": "Slå lyd tl",
  "video.volume_down": "Lydstyrke ned",
  "video.volume_up": "Lydstyrke op",
  "visibility_modal.button_title": "Indstil synlighed",
  "visibility_modal.direct_quote_warning.text": "Hvis du gemmer de aktuelle indstillinger, vil det indlejrede citat blive konverteret til et link.",
  "visibility_modal.direct_quote_warning.title": "Citater kan ikke indlejres i private omtaler",
  "visibility_modal.header": "Synlighed og interaktion",
  "visibility_modal.helper.direct_quoting": "Private omtaler forfattet på Mastodon kan ikke citeres af andre.",
  "visibility_modal.helper.privacy_editing": "Synlighed kan ikke ændres, efter at et indlæg er offentliggjort.",
  "visibility_modal.helper.privacy_private_self_quote": "Selvcitater fra private indlæg kan ikke gøres offentlige.",
  "visibility_modal.helper.private_quoting": "Kun-følger indlæg forfattet på Mastodon kan ikke citeres af andre.",
  "visibility_modal.helper.unlisted_quoting": "Når folk citerer dig, vil deres indlæg også blive skjult fra trendtidslinjer.",
  "visibility_modal.instructions": "Kontroller, hvem der kan interagere med dette indlæg. Du kan også anvende indstillingerne på alle fremtidige indlæg ved at gå til <link>Præferencer > Standardindstillinger for indlæg</link>.",
  "visibility_modal.privacy_label": "Synlighed",
  "visibility_modal.quote_followers": "Kun følgere",
  "visibility_modal.quote_label": "Hvem kan citere",
  "visibility_modal.quote_nobody": "Kun mig",
  "visibility_modal.quote_public": "Alle",
  "visibility_modal.save": "Gem"
}
